window.esign = window.esign || {};

esign.init = function () {
  $('html').removeClass('no-js').addClass('js');

  Response.create({
    prop: "width",
    prefix: "min-width- r src",
    breakpoints: [767,0],
    lazy: true
  });

  esign.cacheSelectors();
  esign.navigation();
  esign.responsiveVideos();
  esign.matchHeight();
  esign.placeholder();
  esign.scrollSpy();
  esign.modals();
  esign.countryList();
  esign.map();
  esign.starListeners();
  esign.qtip();

  $('#custom-pledge-close').fadeOut();
  $('#how-to-read-close').fadeOut();
  $('#how-to-read-close2').fadeOut();
};

esign.cacheSelectors = function () {
  var $html = $('html');

  esign.cache = {
    // general
    $html: $html,

    version: $html.attr('data-version'),

    // navigation
    $nav: $('.nav-wrap'),

    isMobile: esign.isMobile(),

    color: {
      black: 'rgb(31, 38, 36)',
      grey: 'rgb(166, 166, 166)'
    },

    countries: null,
    approaches1: null,
    approaches2: null,
    mapData1: null,
    mapData1EU27: [],
    mapData1EU28: [],
    mapData2: null,
    mapData2EU27: [],
    mapData2EU28: [],

    averagesAbs1: null,
    averagesAbs2: null,
    minAbs1: null,
    minAbs2: null,
    maxAbs1: null,
    maxAbs2: null,

    map: null,
    filenameMap: '',
    isSecond: null,
    isAbsolute: false,
    dataSelected: null,
    isoSelected: '',
    countrySelected: '',
    starFilterActive: false,
    grossAverageCheck: false,
    currentFilterSelector: null,
    currentFilterApproach: null,

    $absoluteTrigger: $('#absolute'),
    $relativeTrigger: $('#relative'),
    $absoluteTrigger2: $('#absolute2'),
    $relativeTrigger2: $('#relative2'),

    warmingAvg: null,
    warmingAvgEU27: [],
    warmingAvgEU28: [],
    warmingAvgUpdated: null,
    warmingAvgUpdatedEU27: [],
    warmingAvgUpdatedEU28: [],

    warmingHigh: null,
    warmingHighEU27: [],
    warmingHighEU28: [],
    warmingHighUpdated: null,
    warmingHighUpdatedEU27: [],
    warmingHighUpdatedEU28: [],
    warmingHighMeinshausen: null,
    warmingHighMeinshausenEU27: [],
    warmingHighNationalEUTargets: null,
    warmingHighNationalEUTargetsEU27: [],

    warmingLow: null,
    warmingLowEU27: [],
    warmingLowEU28: [],
    warmingLowUpdated: null,
    warmingLowUpdatedEU27: [],
    warmingLowUpdatedEU28: [],
    warmingLowMeinshausen: null,
    warmingLowMeinshausenEU27: [],
    warmingLowNationalEUTargets: null,
    warmingLowNationalEUTargetsEU27: [],

    warmingConsistencyData: null,
    warmingConsistencyDataUpdated: null,
    warmingConsistencyDataMeinshausen: null,
    warmingConsistencyDataNationalEUTargets: null,
    warmingConsistencyX: null,
    warmingConsistencyY: null,

    warmingMode: 2, // 0 = avg, 1 = high (conditional), 2 = low (unconditional)
    warmingModeUpdated: true,
    warmingSource: 1, // 0 = Climate Action Tracker, 1 = Meinshausen et al. 2022, 2 = National EU targets

    countriesEU27: ['AUT', 'BEL', 'BGR', 'HRV', 'CYP', 'CZE', 'DNK', 'EST', 'FIN', 'FRA', 'DEU', 'GRC', 'HUN', 'IRL', 'ITA', 'LVA', 'LTU', 'LUX', 'MLT', 'NLD', 'POL', 'PRT', 'ROU', 'SVK', 'SVN', 'ESP', 'SWE'],
    countriesEU28: ['AUT', 'BEL', 'BGR', 'HRV', 'CYP', 'CZE', 'DNK', 'EST', 'FIN', 'FRA', 'DEU', 'GRC', 'HUN', 'IRL', 'ITA', 'LVA', 'LTU', 'LUX', 'MLT', 'NLD', 'POL', 'PRT', 'ROU', 'SVK', 'SVN', 'ESP', 'SWE', 'GBR'],
    warmingNonAssessedUpdatedTargets: ['ALB', 'AND', 'AGO', 'ATG', 'ARG', 'ARM', 'BHR', 'BGD', 'BRB', 'BLR', 'BLZ', 'BEN', 'BOL', 'BIH', 'BRN', 'BFA', 'BDI', 'CPV', 'KHM', 'CMR', 'CAF', 'TCD', 'COM', 'COG', 'COD', 'CIV', 'CUB', 'DOM', 'ETH', 'SLV', 'SWZ', 'FJI', 'GEO', 'GHA', 'GRD', 'GTM', 'GIN', 'GNB', 'HND', 'ISL', 'IRQ', 'JAM', 'JOR', 'PRK', 'KWT', 'KGZ', 'LAO', 'LBN', 'LBR', 'MWI', 'MYS', 'MDV', 'MLI', 'MHL', 'MRT', 'MUS', 'MDA', 'MCO', 'MNG', 'MNE', 'MOZ', 'MMR', 'NAM', 'NRU', 'NIC', 'NER', , 'OMN', 'PAK', 'PSE', 'PAN', 'PHL', 'PNG', 'PRY', 'QAT', 'RWA', 'KNA', 'LCA', 'WSM', 'SAU', 'STP', 'SEN', 'SYC', 'SLE', 'SLB', 'SOM', 'SSD', 'LKA', 'SDN', 'SUR', 'TJK', 'TZA', 'TGO', 'TON', 'TUN', 'UGA', 'UZB', 'VUT', 'VEN', 'ZMB', 'ZWE'],
    countriesNationalEUTargets: ['FRA', 'DEU', 'CZE', 'DNK', 'EST', 'GRC', 'HUN', 'IRL', 'LVA', 'LTU', 'NLD', 'PRT', 'ESP'],
  }
};

esign.isMobile = function () {
  var deviceAgent = navigator.userAgent.toLowerCase(),
    isMobile = (deviceAgent.match(/(iphone|ipod|ipad)/) ||
      deviceAgent.match(/(android)/)  ||
      deviceAgent.match(/(iemobile)/) ||
      deviceAgent.match(/blackberry/i) ||
      deviceAgent.match(/bada/i)) ||
      (/OS [1-4]_[0-9_]+ like Mac OS X/i.test(navigator.userAgent));

  if(isMobile) {
    $('html').addClass('mobile');
  } else {
    $('html').addClass('no-mobile');
  }

  return isMobile;
};

esign.navigation = function () {
  $('.main-nav__trigger').click(function(e) {
    e.preventDefault();
    $(this).next('.nav-wrap').slideToggle('fast');
  });

  Response.crossover('width', function() {
    if(Response.band(767)) {
      esign.cache.$nav.css('display', 'block');
    } else {
      esign.cache.$nav.css('display', 'none');
    }
  });
};

esign.responsiveVideos = function () {
  $('iframe[src*="youtube.com/embed"], iframe[src*="youtube-nocookie.com/embed"], iframe[src*="player.vimeo"]').wrap('<div class="video-container"></div>');
};

esign.matchHeight = function () {
  $('.mh > *').matchHeight();
};

/* IE placeholder text */
esign.placeholder = function () {
  $('input, textarea').placeholder();
};

/* Bootstrap scroll position */
esign.scrollSpy = function () {
  $('body').scrollspy({
    target: '.bs-docs-sidebar',
    offset: 80
  });
};

/* Modals */
esign.modals = function () {
  esign.cache.dataSelected = false;

  // btns
  $('.modal-button, .main-modal-trigger').click(function(e) {
    e.preventDefault();
    var $modal;

    if($(this).hasClass('main-modal-trigger')) {
      $modal = $('#main-modal');
    } else {
      $modal = $($(this).attr('href'));
    }

    /* convert to md-cover if height > window height or device is mobile */
    if($modal.height() > $(window).height() || esign.cache.isMobile) {

      if(!$modal.hasClass('md-cover')) {

        var $close = $modal.find('.md-close');

        $modal
          .addClass('md-cover')
          .find('.md-content')
          .wrapInner('<div class="md-center"><div class="container small"></div></div>')
          .after($close);

        $close.wrap('<div class="md-topbar"></div>');
      }
    }

    if($modal) {
      // remove current modal
      $('.md-show').removeClass('md-show');
      esign.cache.$html.removeClass('noscroll');

      // show modal
      $modal.toggleClass('md-show');
      if($modal.hasClass('md-cover')) {
        esign.cache.$html.addClass('noscroll');
      }

      location.hash = '#open-' + $modal.attr('id');
    }
  });

  // open modal from hash
  var hash = window.location.hash;
  if(hash.indexOf('#open-') >= 0) {
    var itemId = hash.replace('open-',''),
      $modal = $(itemId);

    if($modal.length && esign.cache.dataSelected) {
      $modal.addClass('md-show');
      if($modal.hasClass('md-cover')) {
        esign.cache.$html.addClass('noscroll');
      }
    } else {
      location.hash = '';
      esign.resetState();
    }
  }

  // close modal
  $('.md-close-trigger, .md-overlay').click(function(e) {
    esign.closeModal();
  });

  // handle keyboard events
  $(document).on('keydown', function(e) {
    var tag = e.target.tagName.toLowerCase();

    if (tag !== 'input' && tag !== 'textarea') {
      // hide modal on escape
      if(e.which === 27 && $('.md-show').length) {
        esign.closeModal();
      }

      if(e.which === 77) {
        $('.main-modal-trigger').trigger('click');
      }
    }
  });

  var $triggerFirstGraph = $('#first-ndc-graph');
  var $triggerUpdatedGraph = $('#updated-ndc-graph');

  if ($triggerFirstGraph.length) {
    $triggerFirstGraph.click(function (e) {
      e.preventDefault();

      var isoSelected = esign.cache.isoSelected;

      if (esign.cache.warmingMode !== false && !$triggerFirstGraph.hasClass('active')) {
        $triggerUpdatedGraph.removeClass('active');
        $triggerFirstGraph.addClass('active');
        esign.closeModal();
        $('#first-ndc').click();

        window.setTimeout(function() {
          if (isoSelected === 'EU27') {
            $('[data-iso="EU28"]').click();
          } else {
            $('[data-iso="' + isoSelected + '"]').click();
          }
        }, 300);
      }
    });
  }

  if ($triggerUpdatedGraph.length) {
    $triggerUpdatedGraph.click(function (e) {
      e.preventDefault();

      var isoSelected = esign.cache.isoSelected;

      if (esign.cache.warmingMode !== true && !$triggerUpdatedGraph.hasClass('active')) {
        $triggerFirstGraph.removeClass('active');
        $triggerUpdatedGraph.addClass('active');
        esign.closeModal();
        $('#updated-ndc').click();

        window.setTimeout(function() {
          if (isoSelected === 'EU28') {
            $('[data-iso="EU27"]').click();
          } else {
            $('[data-iso="' + isoSelected + '"]').click();
          }
        }, 300);
      }
    });
  }
};

esign.closeModal = function () {
  $('.md-show').removeClass('md-show');
  esign.cache.$html.removeClass('noscroll');
  location.hash = '';
  esign.resetState();
};

/* Country list */
esign.countryList = function () {
  if($('#country-list').length) {
    if (esign.cache.countries !== null) {
      initCountryList();
    } else {
      $.getJSON('assets/data/countries.json?v=' + esign.cache.version, function(data) {
        esign.cache.countries = data;
        initCountryList();
      });
    }
  }

  function initCountryList() {
    for(var i = 0; i < esign.cache.countries.length; i++ ) {
      if(esign.cache.countries[i]['iso-a3'] !== 'EARTH') {
        esign.cache.countries[i]['country'] = esign.cache.countries[i]['country'].toLowerCase().replace(/(^|\s)[a-z]/g, function (f) {
          return f.toUpperCase();
        });
        $('#country-list ul').append('<li data-iso="' + esign.cache.countries[i]['iso-a3'] + '" data-country="' + esign.cache.countries[i]['country'] + '"><p class="country">' + esign.cache.countries[i]['country'] + '</p></li>');
      }
      if(esign.cache.countries[i]['country'].includes(',')) esign.cache.countries[i]['country'] = esign.cache.countries[i]['country'].split(',')[1].trim() + ' ' + esign.cache.countries[i]['country'].split(',')[0];
    }

    var list = new List('country-list', {
      valueNames: ['country'],
      sort:['country'],
    });

    list.sort('country', {
      asc: true,
      sortFunction: function(itemA, itemB) {
        var sort = list.utils.naturalSort;
        var sortKeyA = itemA._values.country === 'European Union (27)' || itemA._values.country === 'European Union (28)' ? 'A ' + itemA._values.country : itemA._values.country;
        var sortKeyB = itemB._values.country === 'European Union (27)' || itemB._values.country === 'European Union (28)' ? 'A ' + itemB._values.country : itemB._values.country;
        return sort(sortKeyA, sortKeyB);
      }
    });

    esign.checkListVisibleCountries();
  }
};

esign.checkListVisibleCountries = function () {
  if (esign.cache.warmingModeUpdated) {
    $('[data-iso="EU27"]').show();
    $('[data-iso="EU28"]').hide();
  } else {
    $('[data-iso="EU27"]').hide();
    $('[data-iso="EU28"]').show();
  }
}

/* Init map */
esign.map = function () {
  /* Equity map */
  if($('#map').length) {
    esign.equityMap();
  }

  /* Warming map */
  if($('#map2').length) {
    esign.warmingMap();
  }

  esign.exportMaps();
};

/* Export maps */
esign.exportMaps = function () {
  $('#export-map-print').click(function () {
    esign.cache.map.print();
    $('.colour-legend').removeClass('hidden');
  });

  $('#export-map-png').click(function () {
    esign.cache.map.exportChartLocal({
      type: 'image/png'
    });
    $('.colour-legend').removeClass('hidden');
  });

  $('#export-map-jpg').click(function () {
    esign.cache.map.exportChartLocal({
      type: 'image/jpeg'
    });
    $('.colour-legend').removeClass('hidden');
  });

  $('#export-map-pdf').click(function () {
    esign.cache.map.exportChart({
      type: 'application/pdf'
    });
    $('.colour-legend').removeClass('hidden');
  });

  $('#export-map-svg').click(function () {
    esign.cache.map.exportChartLocal({
      type: 'image/svg+xml'
    });
    $('.colour-legend').removeClass('hidden');
  });
};


/***********************************
 * Equity Map
 ***********************************/
esign.equityMap = function() {
  esign.resetState();
  esign.cache.isSecond = true;
  esign.loadMapData();

  // 1.5 °C
  $('#one').click(function (e) {
    e.preventDefault();

    if(esign.cache.isSecond) {
      esign.cache.isSecond = false;
      $('#two').removeClass('active');
      $('#one').addClass('active');

      $('#two-graph').removeClass('active');
      $('#one-graph').addClass('active');
      esign.loadMapData();
    }
  });

  // 2 °C
  $('#two').click(function (e) {
    e.preventDefault();

    if(!esign.cache.isSecond) {
      esign.cache.isSecond = true;
      $('#one').removeClass('active');
      $('#two').addClass('active');

      $('#one-graph').removeClass('active');
      $('#two-graph').addClass('active');
      esign.loadMapData();
    }
  });
};

/* Load equity map data */
esign.loadMapData = function() {
  if(esign.cache.isSecond) {
    esign.cache.filenameMap = 'Paris Equity Check 2°C [Downloaded from Paris-equity-check.org]';

    if (esign.cache.approaches2 !== null || esign.cache.mapData2 !== null) {
      esign.drawMap(esign.cache.mapData2EU27, 'EU27');
    } else {
      $.getJSON('assets/data/indc_2c.json?v=' + esign.cache.version, function (dataMap) {
        $.getJSON('assets/data/approach_2c.json?v=' + esign.cache.version, function (dataApproach) {
          esign.cache.approaches2 = dataApproach;
          esign.cache.mapData2 = dataMap;

          var EU27 = esign.getValueByIso(esign.cache.mapData2, 'EU27');
          var EU28 = esign.getValueByIso(esign.cache.mapData2, 'EU28');

          for (var i = 0; i < esign.cache.mapData2.length; i += 1) {
            if (esign.cache.countriesEU27.indexOf(esign.cache.mapData2[i]['iso-a3']) > -1) {
              esign.cache.mapData2EU27.push({
                'iso-a3': esign.cache.mapData2[i]['iso-a3'],
                value: EU27.value
              });
            } else {
              esign.cache.mapData2EU27.push(esign.cache.mapData2[i]);
            }

            if (esign.cache.countriesEU28.indexOf(esign.cache.mapData2[i]['iso-a3']) > -1) {
              esign.cache.mapData2EU28.push({
                'iso-a3': esign.cache.mapData2[i]['iso-a3'],
                value: EU28.value
              });
            } else {
              esign.cache.mapData2EU28.push(esign.cache.mapData2[i]);
            }
          }

          esign.drawMap(esign.cache.mapData2EU27, 'EU27');
        });
      });
    }
  } else {
    esign.cache.filenameMap = 'Paris Equity Check 1.5°C [Downloaded from Paris-equity-check.org]';

    if (esign.cache.approaches1 !== null || esign.cache.mapData1 !== null) {
      esign.drawMap(esign.cache.mapData1EU27, 'EU27');
    } else {
      $.getJSON('assets/data/indc_1p5c.json?v=' + esign.cache.version, function (dataMap) {
        $.getJSON('assets/data/approach_1p5c.json?v=' + esign.cache.version, function (dataApproach) {
          esign.cache.approaches1 = dataApproach;
          esign.cache.mapData1 = dataMap;

          var EU27 = esign.getValueByIso(esign.cache.mapData1, 'EU27');
          var EU28 = esign.getValueByIso(esign.cache.mapData1, 'EU28');

          for (var i = 0; i < esign.cache.mapData1.length; i += 1) {
            if (esign.cache.countriesEU27.indexOf(esign.cache.mapData1[i]['iso-a3']) > -1) {
              esign.cache.mapData1EU27.push({
                'iso-a3': esign.cache.mapData1[i]['iso-a3'],
                value: EU27.value
              });
            } else {
              esign.cache.mapData1EU27.push(esign.cache.mapData1[i]);
            }

            if (esign.cache.countriesEU28.indexOf(esign.cache.mapData1[i]['iso-a3']) > -1) {
              esign.cache.mapData1EU28.push({
                'iso-a3': esign.cache.mapData1[i]['iso-a3'],
                value: EU28.value
              });
            } else {
              esign.cache.mapData1EU28.push(esign.cache.mapData1[i]);
            }
          }

          esign.drawMap(esign.cache.mapData1EU27, 'EU27');
        });
      });
    }
  }
};

/* Draw map */
esign.drawMap = function(data, seriesName) {
  var seriesOptions = function (seriesData, seriesName) {
    return {
      name: seriesName,
      data: seriesData,
      mapData: Highcharts.geojson(Highcharts.maps['custom/world-eckert3-highres']),
      backgroundColor: '#FCFFC5',
      joinBy: 'iso-a3',
      cursor: 'pointer',
      nullInteraction: true,
      states: {
        hover: {
          borderColor: 'grey',
          color: this.color
        }
      },
      dataLabels: {
        enabled: false,
        useHTML: true
      },
      point: {
        events:{
          click: function () {
            esign.cache.dataSelected = true;
            esign.cache.isoSelected = this['iso-a3'];

            if (this.series && this.series.name && this.series.name === 'EU27' && esign.cache.countriesEU27.indexOf(esign.cache.isoSelected) > -1) {
              esign.cache.isoSelected = 'EU27';

            } else if (this.series && this.series.name && this.series.name === 'EU28' && esign.cache.countriesEU28.indexOf(esign.cache.isoSelected) > -1) {
              esign.cache.isoSelected = 'EU28';
            }

            for(var i = 0; i < esign.cache.countries.length; i++ ) {
              if(esign.cache.countries[i]['iso-a3'] === esign.cache.isoSelected) esign.cache.countrySelected = esign.cache.countries[i]['country'];
            }

            esign.openChart();
          },
          mouseOver: function () {
            if (esign.cache.countriesEU27.indexOf(this['iso-a3']) > -1) {
              esign.fillStars('EU27', '.stars');
            } else {
              esign.fillStars(this['iso-a3'], '.stars');
            }
          },
          mouseOut: function () {
            esign.emptyStars('.stars');
          }
        }
      },
      nullColor: '#fff',
      borderColor: '#D2D2D2',
      borderWidth: 1
    };
  };

  esign.cache.map = new Highcharts.Map('map', {
    title: {
      text: esign.cache.filenameMap,
      style: {
        fontSize: '8'
      },
      useHTML: true
    },
    exporting: {
      enabled: false,
      filename: esign.cache.filenameMap,
      fallbackToExportServer: true,
      chartOptions: {
        credits: {
          enabled: true,
          href:"#",
          position: {
            align:"right",
            verticalAlign:"bottom",
            x: -10,
            y: -5
          },
          style: {"cursor": "default", "font-size":"6pt"},
          text:"From Paris-equity-check.org, based on Robiou du Pont et al. (2017), Nature Climate Change"
        },
        chart:{
          events: {
            load: function(event) {
              this.renderer.image('assets/images/legend.png',10,300,100,85).add();
            }
          }
        }
      }
    },
    chart: {
      margin: [0, 0, 0, 0],
      style: {
        fontFamily: 'Open Sans'
      },
      backgroundColor: '#f6faff',
      pinchType: 'none',
    },
    credits: false,
    mapNavigation: {
      enabled: true,
      enableMouseWheelZoom: false,
      enableDoubleClickZoom: false,
      enableDoubleClickZoomTo: false,
      buttonOptions: {
        align: 'right',
        verticalAlign: 'bottom',
        x: -20,
        theme: {
          fill: 'white',
          'stroke-width': 1,
          stroke: 'silver',
          r: 0,
          states: {
            hover: {
              fill: '#f5f5f5'
            }
          }
        }
      },
      buttons: {
        zoomIn: {
          y: -20
        },
        zoomOut: {
          y: 8
        }
      }
    },
    colorAxis: {
      stops: [
        [0.1, '#FFFFFD'],
        [0.2, '#f7f4d7'],
        [0.3, '#dee693'],
        [0.5, '#c5d750'],
        [0.6, '#77af52'],
        [0.8, '#39925c']
      ]
    },
    legend: {
      enabled: false,
      align: 'center',
      x: 0,
      y: 10,
      color: '#fff',
      layout: 'horizontal',
      floating: false,
      verticalAlign: 'bottom',
      shadow: false,
      border: 0,
      borderRadius: 0,
      borderWidth: 0
    },
    tooltip: {
      enabled: !esign.cache.isMobile,
      useHTML: true,
      borderWidth:0,
      borderRadius:0,
      padding: 5,
      minWidth: 300,
      backgroundColor: false,
      shadow: false,
      hideDelay: 30,
      formatter: function () {
        var iso = this.point['iso-a3'],
          indc,
          indcDescription,
          name,
          classCer, classGdr, classCap, classCpc, classEpc;

        this.point.options.value != null ? indc = this.point.options.value : indc = 'N/A';

        if(indc === 1) {
          indcDescription = 'NDC consistent with ' + indc + ' equity approach.';
        } else {
          indcDescription = 'NDC consistent with ' + indc + ' equity approaches.';
        }

        for(var i = 0; i < esign.cache.countries.length; i++ ) {
          if(esign.cache.countries[i]['iso-a3'] === iso) name = esign.cache.countries[i]['country'];
        }

        function getCountryIso(value) {
          return value['iso-a3'] === iso;
        }

        var countryApproaches = esign.cache.isSecond ? esign.cache.approaches2.filter(getCountryIso) : esign.cache.approaches1.filter(getCountryIso);

        for(var i = 0; i < countryApproaches.length; i ++) {
          if(countryApproaches[i]['approach'] === 'CER' && countryApproaches[i]['indc'] === 'X') classCer = 'active';
          if(countryApproaches[i]['approach'] === 'GDR' && countryApproaches[i]['indc'] === 'X') classGdr = 'active';
          if(countryApproaches[i]['approach'] === 'CAP' && countryApproaches[i]['indc'] === 'X') classCap = 'active';
          if(countryApproaches[i]['approach'] === 'CPC' && countryApproaches[i]['indc'] === 'X') classCpc = 'active';
          if(countryApproaches[i]['approach'] === 'EPC' && countryApproaches[i]['indc'] === 'X') classEpc = 'active';
        }

        if (iso === 'EU27' || (this.series && this.series.name && this.series.name === 'EU27' && esign.cache.countriesEU27.indexOf(iso) > -1)) {
          return '<div class="tool"><h4>' + 'European Union (27)'
            + '</h4><div class="approach">' + indcDescription + '<br>See country list for individual EU member states.</div><div class="stars">'
            + '<span class="icon-rand star star--cer active"><span>CER</span></span>'
            + '<span class="icon-rand star star--gdr"><span>GDR</span></span>'
            + '<span class="icon-rand star star--cap"><span>CAP</span></span>'
            + '<span class="icon-rand star star--cpc"><span>CPC</span></span>'
            + '<span class="icon-rand star star--epc"><span>EPC</span></span></div></div>';
        } else {
          return '<div class="tool"><h4>' + name
            + '</h4><div class="approach">' + indcDescription + '</div><div class="stars">'
            + '<span class="icon-rand star star--cer ' + classCer + '"><span>CER</span></span>'
            + '<span class="icon-rand star star--gdr ' + classGdr + '"><span>GDR</span></span>'
            + '<span class="icon-rand star star--cap ' + classCap + '"><span>CAP</span></span>'
            + '<span class="icon-rand star star--cpc ' + classCpc + '"><span>CPC</span></span>'
            + '<span class="icon-rand star star--epc ' + classEpc + '"><span>EPC</span></span></div></div>';
        }
      }
    },
    series: [seriesOptions(data, seriesName)]
  });

  // Listeners
  var countryListItem = $('#country-list ul li'),
    tooltip;

  countryListItem.click(function (event) {
    esign.cache.dataSelected = true;
    var iso = this.getAttribute('data-iso');
    if(esign.cache.isoSelected !== iso) {
      for(var i = 0; i < esign.cache.map.series[0].data.length; i++) {
        if(esign.cache.map.series[0].data[i]['iso-a3'] === iso) {
          tooltip = esign.cache.map.series[0].data[i];
          tooltip.firePointEvent('click', event);
        }
      }
    }
  });

  countryListItem.mouseover(function () {
    if(!esign.cache.isMobile) {
      var iso = this.getAttribute('data-iso');
      for (var i = 0; i < esign.cache.map.series[0].data.length; i++) {
        if (esign.cache.map.series[0].data[i]['iso-a3'] === iso) {
          tooltip = esign.cache.map.series[0].data[i];

          if (tooltip && tooltip.setState) {
            tooltip.setState('hover');
          }

          esign.cache.map.tooltip.update({
            positioner: function(val, val2, val3) {
              if (iso === 'EU27' || iso === 'EU28') {
                return { x: this.chart.plotWidth/2, y: this.chart.plotHeight/3 };
              }
              return { x: val3.plotX, y: val3.plotY };
            }
          });

          esign.cache.map.tooltip.refresh(tooltip);
        }
      }
      esign.fillStars(iso, '.stars');
    }
  });

  countryListItem.mouseout(function () {
    if(!esign.cache.isMobile) {
      if (esign.cache.map !== undefined) {
        if (tooltip && tooltip.setState) {
          tooltip.setState();
        }
        esign.cache.map.tooltip.hide();
      }
      esign.emptyStars('.stars');
    }
  });

  countryListItem.mouseenter(function () {
    if(!esign.cache.isMobile) {
      var iso = this.getAttribute('data-iso');

      if (iso === 'EU27') {
        esign.cache.map.series[0].remove(true);
        if (esign.cache.isSecond) {
          esign.cache.map.addSeries(seriesOptions(esign.cache.mapData2EU27, 'EU27'));
        } else {
          esign.cache.map.addSeries(seriesOptions(esign.cache.mapData1EU27, 'EU27'));
        }
      } else if (esign.cache.countriesEU27.indexOf(iso) > -1) {
        esign.cache.map.series[0].remove(true);
        if (esign.cache.isSecond) {
          esign.cache.map.addSeries(seriesOptions(esign.cache.mapData2, ''));
        } else {
          esign.cache.map.addSeries(seriesOptions(esign.cache.mapData1, ''));
        }
      }
    }
  });

  countryListItem.mouseleave(function () {
    if(!esign.cache.isMobile) {
      var iso = this.getAttribute('data-iso');

      if (esign.cache.countriesEU27.indexOf(iso) > -1) {
        esign.cache.map.series[0].remove(true);
        if (esign.cache.isSecond) {
          esign.cache.map.addSeries(seriesOptions(esign.cache.mapData2EU27, 'EU27'));
        } else {
          esign.cache.map.addSeries(seriesOptions(esign.cache.mapData1EU27, 'EU27'));
        }
      }
    }
  });

  if(esign.cache.starFilterActive) {
    esign.filterByStars();
  }
};

/* Add star click events */
esign.starListeners = function () {

  var $starCer = $('.map-legend .star--cer');
  var $starGdr = $('.map-legend .star--gdr');
  var $starCap = $('.map-legend .star--cap');
  var $starCpc = $('.map-legend .star--cpc');
  var $starEpc = $('.map-legend .star--epc');

  esign.cache.starFilterActive = false;

  $starCer.click(function() {
    filter($starCer, 'CER');
  });
  $starGdr.click(function() {
    filter($starGdr, 'GDR');
  });
  $starCap.click(function() {
    filter($starCap, 'CAP');
  });
  $starCpc.click(function() {
    filter($starCpc, 'CPC');
  });
  $starEpc.click(function() {
    filter($starEpc, 'EPC');
  });

  function filter(selector, approach) {

    if(esign.cache.starFilterActive) {
      if(esign.cache.currentFilterSelector.selector === selector.selector) {
        esign.cache.currentFilterSelector.removeClass('filter-active');
        $('.colour-legend').removeClass('hidden');
        esign.cache.currentFilterSelector = null;
        esign.cache.starFilterActive = false;
        esign.loadMapData();
      } else {
        esign.cache.starFilterActive = true;
        esign.cache.currentFilterSelector = selector;
        esign.cache.currentFilterApproach = approach;
        $('.filter-active').removeClass('filter-active');
        esign.cache.currentFilterSelector.addClass('filter-active');
        $('.colour-legend').addClass('hidden');
        esign.loadMapData();
      }
    } else {
      esign.cache.starFilterActive = true;
      esign.cache.currentFilterSelector = selector;
      esign.cache.currentFilterApproach = approach;
      esign.cache.currentFilterSelector.addClass('filter-active');
      $('.colour-legend').addClass('hidden');
      esign.filterByStars();
    }

  }
};

/* Fill # NDC stars */
esign.fillStars = function(iso, selector) {
  function getCountryIso(value) {
    return value['iso-a3'] === iso;
  }

  var countryApproaches = esign.cache.isSecond ? esign.cache.approaches2.filter(getCountryIso) : esign.cache.approaches1.filter(getCountryIso);

  $('.stars-legend').addClass('hover');

  for(var i = 0; i < countryApproaches.length; i ++) {
    if(countryApproaches[i]['approach'] === 'CER' && countryApproaches[i]['indc'] === 'X') $(selector + ' .star--cer').addClass('active');
    if(countryApproaches[i]['approach'] === 'GDR' && countryApproaches[i]['indc'] === 'X') $(selector + ' .star--gdr').addClass('active');
    if(countryApproaches[i]['approach'] === 'CAP' && countryApproaches[i]['indc'] === 'X') $(selector + ' .star--cap').addClass('active');
    if(countryApproaches[i]['approach'] === 'CPC' && countryApproaches[i]['indc'] === 'X') $(selector + ' .star--cpc').addClass('active');
    if(countryApproaches[i]['approach'] === 'EPC' && countryApproaches[i]['indc'] === 'X') $(selector + ' .star--epc').addClass('active');
  }
};

/* Reset # NDC stars */
esign.emptyStars = function(selector) {
  $(selector + ' .star').removeClass('active');
  $('.stars-legend').removeClass('hover');
};

/* Filter map by stars */
esign.filterByStars = function () {
  var matchedCountries = [];
  var color = '';

  if (esign.cache.isSecond) {
    esign.cache.approaches2.map(function(value, i) {
      if(value['approach'] === esign.cache.currentFilterApproach && value['indc'] === 'X') {
        matchedCountries.push(esign.cache.approaches2[i]['iso-a3']);
      }
    });
  } else {
    esign.cache.approaches1.map(function(value, i) {
      if(value['approach'] === esign.cache.currentFilterApproach && value['indc'] === 'X') {
        matchedCountries.push(esign.cache.approaches1[i]['iso-a3']);
      }
    });
  }

  if(esign.cache.currentFilterApproach === 'CER') color = '#ff8950';
  if(esign.cache.currentFilterApproach === 'GDR') color = '#965c83';
  if(esign.cache.currentFilterApproach === 'CAP') color = '#406b80';
  if(esign.cache.currentFilterApproach === 'CPC') color = '#ffc850';
  if(esign.cache.currentFilterApproach === 'EPC') color = '#8bced7';

  updatePoints(function () {
    setTimeout(function(){
      esign.cache.map.series[0].points.map(function(point) {
        point.setState();
      });
    }, 0);
  });

  function updatePoints(cb) {
    esign.cache.map.series[0].points.map(function(point) {
      if(matchedCountries.includes(point['iso-a3'])) {
        point.color = color;
      } else {
        point.color = '#F4F4F4';
      }
    });
    cb();
  }
};

/* Open chart view */
esign.openChart = function() {
  esign.emptyStars('.stars-graph');
  $('.modal-button-graph').trigger('click');
  $('.graph-country').text(esign.cache.countrySelected);

  esign.fairnessStatement(esign.cache.isoSelected);

  // 1.5 °C
  $('#one-graph').click(function (e) {
    e.preventDefault();

    if(esign.cache.isSecond) {
      esign.cache.isSecond = false;
      esign.emptyStars('.stars-graph');

      $('#two-graph').removeClass('active');
      $('#one-graph').addClass('active');

      $('#two').removeClass('active');
      $('#one').addClass('active');

      esign.loadChartData();
      esign.loadMapData();
    }
  });

  // 2 °C
  $('#two-graph').click(function (e) {
    e.preventDefault();

    if(!esign.cache.isSecond) {
      esign.cache.isSecond = true;
      esign.emptyStars('.stars-graph');

      $('#one-graph').removeClass('active');
      $('#two-graph').addClass('active');

      $('#one').removeClass('active');
      $('#two').addClass('active');

      esign.loadChartData();
      esign.loadMapData();
    }
  });

  esign.loadChartData();
};

/* Load chart data */
esign.loadChartData = function () {

  if (esign.cache.isSecond) {
    createData2(2010);
  } else {
    createData1(2010);
  }

  // Absolute graph
  esign.cache.$absoluteTrigger.click(function (e) {
    e.preventDefault();

    if (!esign.cache.isAbsolute) {
      esign.cache.isAbsolute = true;
      esign.cache.$relativeTrigger.removeClass('active');
      esign.cache.$absoluteTrigger.addClass('active');

      if (esign.cache.isSecond) {
        createData2(2010);
      } else {
        createData1(2010);
      }
    }
  });

  // Relative graph
  $('.rel-year').click(function (e) {
    e.preventDefault();

    esign.cache.isAbsolute = false;
    esign.cache.$relativeTrigger.addClass('active');
    esign.cache.$absoluteTrigger.removeClass('active');

    var year = this.text.replace('rel-', '');
    esign.cache.$relativeTrigger.html('Relative to ' + year + ' <span class="caret"></span><span class="sr-only">Toggle Dropdown</span>');

    if (esign.cache.isSecond) {
      createData2(year);
    } else {
      createData1(year);
    }
  });
};

function createData1(year) {
  if (esign.cache.averagesAbs1 !== null && esign.cache.minAbs1 !== null && esign.cache.maxAbs1) {
    esign.fillStars(esign.cache.isoSelected, '.stars-graph');
    esign.createChart(year);
  } else {
    $.when(
      $.getJSON('assets/data/avg_abs_1p5c.json?v=' + esign.cache.version, function(data) {
        esign.cache.averagesAbs1 = data;
      }),
      $.getJSON('assets/data/min_abs_1p5c.json?v=' + esign.cache.version, function(data) {
        esign.cache.minAbs1 = data;
      }),
      $.getJSON('assets/data/max_abs_1p5c.json?v=' + esign.cache.version, function(data) {
        esign.cache.maxAbs1 = data;
      })
    ).then(function() {
      esign.fillStars(esign.cache.isoSelected, '.stars-graph');
      esign.createChart(year);
    });
  }
}

function createData2(year) {
  if (esign.cache.averagesAbs2 !== null && esign.cache.minAbs2 !== null && esign.cache.maxAbs2) {
    esign.fillStars(esign.cache.isoSelected, '.stars-graph');
    esign.createChart(year);
  } else {
    $.when(
      $.getJSON('assets/data/avg_abs_2c.json?v=' + esign.cache.version, function(data) {
        esign.cache.averagesAbs2 = data;
      }),
      $.getJSON('assets/data/min_abs_2c.json?v=' + esign.cache.version, function(data) {
        esign.cache.minAbs2 = data;
      }),
      $.getJSON('assets/data/max_abs_2c.json?v=' + esign.cache.version, function(data) {
        esign.cache.maxAbs2 = data;
      })
    ).then(function() {
      esign.fillStars(esign.cache.isoSelected, '.stars-graph');
      esign.createChart(year);
    });
  }
}

/* Create chart */
esign.createChart = function(year) {
  var yearMin = 1990,
    yearMax = 2100,
    unitK = 'ktCO2eq',
    unitM = 'MtCO2eq',
    unitG = 'GtCO2eq',
    unit = unitK,
    divider = 1,
    indcAbs,
    indcLowAbs,
    indcHighAbs,
    indcRel,
    indcLowRel,
    indcHighRel;

  calculateAverages();

  // Averages
  function calculateAverages() {
    function getCountryIso(value) {
      // i++;
      return value['iso-a3'] === esign.cache.isoSelected;
    }

    var dataAverages = esign.cache.isSecond ? esign.cache.averagesAbs2.filter(getCountryIso) : esign.cache.averagesAbs1.filter(getCountryIso);

    // CER
    function getCer(value) {
      return value['approach'] === 'CER';
    }
    var dataCerAvg = dataAverages.filter(getCer);
    // GDR
    function getGdr(value) {
      return value['approach'] === 'GDR';
    }
    var dataGdrAvg = dataAverages.filter(getGdr);
    // CAP
    function getCap(value) {
      return value['approach'] === 'CAP';
    }
    var dataCapAvg = dataAverages.filter(getCap);
    // CPC
    function getCpc(value) {
      return value['approach'] === 'CPC';
    }
    var dataCpcAvg = dataAverages.filter(getCpc);
    // EPC
    function getEpc(value) {
      return value['approach'] === 'EPC';
    }
    var dataEpcAvg = dataAverages.filter(getEpc);
    // NDC
    function getIndc(value) {
      return value['INDCamb'] === 'INDC';
    }
    var dataIndc = dataAverages.filter(getIndc);
    indcAbs = dataIndc[0]['INDC%'];
    // NDC low
    function getIndcLow(value) {
      return value['INDCamb'] === 'INDC_low';
    }
    var dataIndcLow = dataAverages.filter(getIndcLow);
    indcLowAbs = dataIndcLow[0]['INDC%'];
    // NDC high
    function getIndcHigh(value) {
      return value['INDCamb'] === 'INDC_high';
    }
    var dataIndcHigh = dataAverages.filter(getIndcHigh);
    indcHighAbs = dataIndcHigh[0]['INDC%'];

    var cerAvg = [], gdrAvg = [], capAvg = [], cpcAvg = [], epcAvg = [], histAvg = [];

    if(esign.cache.isAbsolute) {
      for(var i = yearMin; i <= yearMax; i++) {
        cerAvg.push([i, dataCerAvg[0][i]]);
        gdrAvg.push([i, dataGdrAvg[0][i]]);
        capAvg.push([i, dataCapAvg[0][i]]);
        cpcAvg.push([i, dataCpcAvg[0][i]]);
        epcAvg.push([i, dataEpcAvg[0][i]]);
      }
    } else {
      for(var i = yearMin; i <= yearMax; i++) {
        cerAvg.push([i, ((dataCerAvg[0][i]/dataCapAvg[0][year])*100)]);
        gdrAvg.push([i, ((dataGdrAvg[0][i]/dataCapAvg[0][year])*100)]);
        capAvg.push([i, ((dataCapAvg[0][i]/dataCapAvg[0][year])*100)]);
        cpcAvg.push([i, ((dataCpcAvg[0][i]/dataCapAvg[0][year])*100)]);
        epcAvg.push([i, ((dataEpcAvg[0][i]/dataCapAvg[0][year])*100)]);
      }
      indcRel = ((indcAbs/dataCapAvg[0][year]))*100;
    }

    for(var i = 0; i <= 20; i++) {
      histAvg.push(capAvg[i]);
    }

    if (esign.cache.isSecond) {
      calculateRange(esign.cache.minAbs2, esign.cache.maxAbs2, cerAvg, gdrAvg, capAvg, cpcAvg, epcAvg, histAvg);
    } else {
      calculateRange(esign.cache.minAbs1, esign.cache.maxAbs1, cerAvg, gdrAvg, capAvg, cpcAvg, epcAvg, histAvg);
    }
  }

  // Ranges
  function calculateRange(dataMi, dataMa, cerAvg, gdrAvg, capAvg, cpcAvg, epcAvg, histAvg) {

    function getCountryIso(value) {
      return value['iso-a3'] === esign.cache.isoSelected;
    }
    var dataMin = dataMi.filter(getCountryIso);
    var dataMax = dataMa.filter(getCountryIso);

    // CER
    function getCer(value) {
      return value['approach'] === 'CER';
    }
    var dataCerMin = dataMin.filter(getCer);
    var dataCerMax = dataMax.filter(getCer);
    // GDR
    function getGdr(value) {
      return value['approach'] === 'GDR';
    }
    var dataGdrMin = dataMin.filter(getGdr);
    var dataGdrMax = dataMax.filter(getGdr);
    // CAP
    function getCap(value) {
      return value['approach'] === 'CAP';
    }
    var dataCapMin = dataMin.filter(getCap);
    var dataCapMax = dataMax.filter(getCap);
    // CPC
    function getCpc(value) {
      return value['approach'] === 'CPC';
    }
    var dataCpcMin = dataMin.filter(getCpc);
    var dataCpcMax = dataMax.filter(getCpc);
    // EPC
    function getEpc(value) {
      return value['approach'] === 'EPC';
    }
    var dataEpcMin = dataMin.filter(getEpc);
    var dataEpcMax = dataMax.filter(getEpc);

    var cerRange = [], gdrRange = [], capRange = [], cpcRange = [], epcRange = [];
    var maxValue = 0;

    if(esign.cache.isAbsolute) {
      for(var i = yearMin; i <= yearMax; i++) {
        cerRange.push([i, dataCerMin[0][i], dataCerMax[0][i]]);
        gdrRange.push([i, dataGdrMin[0][i], dataGdrMax[0][i]]);
        capRange.push([i, dataCapMin[0][i], dataCapMax[0][i]]);
        cpcRange.push([i, dataCpcMin[0][i], dataCpcMax[0][i]]);
        epcRange.push([i, dataEpcMin[0][i], dataEpcMax[0][i]]);
        max([dataCerMax[0][i], dataGdrMax[0][i], dataCapMax[0][i], dataCpcMax[0][i], dataEpcMax[0][i]]);
      }
    } else {
      for(var i = yearMin; i <= yearMax; i++) {
        if(i >= year) {
          cerRange.push([i, ((dataCerMin[0][i]/dataCapMin[0][year])*100), ((dataCerMax[0][i]/dataCapMax[0][year])*100)]);
          gdrRange.push([i, ((dataGdrMin[0][i]/dataCapMin[0][year])*100), ((dataGdrMax[0][i]/dataCapMax[0][year])*100)]);
          capRange.push([i, ((dataCapMin[0][i]/dataCapMin[0][year])*100), ((dataCapMax[0][i]/dataCapMax[0][year])*100)]);
          cpcRange.push([i, ((dataCpcMin[0][i]/dataCapMin[0][year])*100), ((dataCpcMax[0][i]/dataCapMax[0][year])*100)]);
          epcRange.push([i, ((dataEpcMin[0][i]/dataCapMin[0][year])*100), ((dataEpcMax[0][i]/dataCapMax[0][year])*100)]);
        }
      }
      indcLowRel = ((indcLowAbs/dataCapMin[0][year]))*100;
      indcHighRel = ((indcHighAbs/dataCapMax[0][year]))*100;
    }

    function max(arr) {
      var m = Math.max.apply(null, arr);
      if(m > maxValue) maxValue = m;
    }

    if(maxValue > 999) {
      unit = unitM;
      divider = 1000;
    }
    if(maxValue > 999999) {
      unit = unitG;
      divider = 1000000;
    }

    drawChart(cerAvg, gdrAvg, capAvg, cpcAvg, epcAvg, cerRange, gdrRange, capRange, cpcRange, epcRange, unit, histAvg);
  }

  function drawChart(cerAvg, gdrAvg, capAvg, cpcAvg, epcAvg, cerRange, gdrRange, capRange, cpcRange, epcRange, unit, histAvg) {

    var cerAverageText = 'CER', gdrAverageText = 'GDR', capAverageText = 'CAP', cpcAverageText = 'CPC', epcAverageText = 'EPC',
      cerRangeText = 'CER range', gdrRangeText = 'GDR range', capRangeText = 'CAP range', cpcRangeText = 'CPC range', epcRangeText = 'EPC range',
      relativeYear = year,
      yAxis = {},
      filename,
      chartOptions,
      chart,
      indcData;

    // Chart options & creation
    if(esign.cache.isAbsolute) {
      // Absolute options
      yAxis = {
        title: {
          text: 'Emissions allowances in ' + unit
        },
        plotLines: [{
          value: 0,
          color: 'black',
          width: 2
        }],
        labels: {
          formatter: function () {
            if(unit === unitM) {
              return this.value / divider;
            } else if (unit === unitG) {
              return this.value / divider;
            }
            return this.value;
          }
        }
      };
      filename = esign.cache.countrySelected + ' - Emissions allowances in ' + unit;
    } else {
      // Relative options
      yAxis = {
        title: {
          text: 'Emissions allowances in % of ' + relativeYear + ' levels'
        },
        plotLines: [{
          value: 100,
          color: 'black',
          dashStyle: 'shortdash',
          width: 2
        }, {
          value: 0,
          color: 'black',
          width: 2
        }],
        labels: {
          formatter: function () {
            return this.value;
          }
        }
      };

      var temp;
      esign.cache.isSecond ? temp = '2°C' : temp = '1.5°C';


      filename = esign.cache.countrySelected + ' - Emissions allowances in % of ' + relativeYear + ' levels (' + temp + ') [Downloaded from Paris-equity-check.org]';
    }

    chartOptions = {
      chart: {
        renderTo: 'chart',
        style: {
          fontFamily: 'Open Sans'
        },
        backgroundColor: '#ffffff'
      },
      title: {
        text: esign.cache.countrySelected + " - " + temp,
        useHTML: true
      },
      subtitle: {
        text: '',
        style: {
          color: '#B4B4B4',
          fontSize: '5'
        },
        useHTML: true
      },
      xAxis: {
        title: {
          text: 'Year'
        }
      },
      yAxis: yAxis,
      tooltip: {
        crosshairs: true,
        shared: true,
        useHtml: true,
        borderWidth: 0,
        hideDelay: 30
      },
      legend: {
        title: {
          text: 'Allocated emissions ranges and averages for:',
          style: {
            fontWeight: 'normal'
          }
        },
        enabled: true,
        layout: 'vertical',
        floating: false,
        align: 'center left',
        itemStyle: {
          fontWeight: 'normal',
          fontSize: '10px'
        },
        itemMarginBottom: 1,
        labelFormatter: function () {
          var name = this.name;
          var text = '';

          if(name === 'CER') text = 'CER: Constant emissions ratio';
          if(name === 'GDR') text = 'GDR: Greenhouse development rights';
          if(name === 'CAP') text = 'CAP: Capability';
          if(name === 'CPC') text = 'CPC: Equal cumulative per capita';
          if(name === 'EPC') text = 'EPC: Equal per capita';

          return text;
        }
      },
      exporting: {
        enabled: false,
        filename: filename,
        buttons: {
          contextButton: {
            verticalAlign: 'bottom',
            text: 'export'
          }
        },
        fallbackToExportServer: true,
        chartOptions:{
          credits: {
            enabled: true,
            href:"#",
            position: {
              align:"right",
              verticalAlign:"bottom",
              x: -10,
              y: -190,
            },
            style: {"cursor": "default", "font-size":"6pt"},
            text:"From Paris-equity-check.org, based on Robiou du Pont et al. (2017), Nature Climate Change"
          }
        }
      },
      credits: false,
      series: [{
        name: cerAverageText,
        data: cerAvg,
        zIndex: 10,
        color: '#ff8950',
        marker: {
          lineWidth: 0,
          radius: 0,
          symbol: 'circle',
          lineColor: 'transparent'
        },
        zoneAxis: 'x',
        zones: [{
          value: 2010,
          color: 'transparent'
        }]
      },{
        name: cerRangeText,
        data: cerRange,
        type: 'areasplinerange',
        lineWidth: 0,
        linkedTo: ':previous',
        color: '#ff8950',
        lineColor: '#ff8950',
        fillOpacity: 0.3,
        zIndex: 5
      }, {
        name: gdrAverageText,
        data: gdrAvg,
        zIndex: 9,
        color: '#965c83',
        marker: {
          lineWidth: 0,
          radius: 0,
          symbol: 'circle',
          lineColor: 'transparent'
        },
        zoneAxis: 'x',
        zones: [{
          value: 2010,
          color: 'transparent'
        }]
      },{
        name: gdrRangeText,
        data: gdrRange,
        type: 'areasplinerange',
        lineWidth: 0,
        linkedTo: ':previous',
        color: '#965c83',
        lineColor: '#965c83',
        fillOpacity: 0.3,
        zIndex: 4
      }, {
        name: capAverageText,
        data: capAvg,
        zIndex: 8,
        color: '#406b80',
        marker: {
          lineWidth: 0,
          radius: 0,
          symbol: 'circle',
          lineColor: 'transparent'
        },
        zoneAxis: 'x',
        zones: [{
          value: 2010,
          color: 'transparent'
        }]
      },{
        name: capRangeText,
        data: capRange,
        type: 'areasplinerange',
        lineWidth: 0,
        linkedTo: ':previous',
        color: '#406b80',
        lineColor: '#406b80',
        fillOpacity: 0.3,
        zIndex: 3
      },{
        name: cpcAverageText,
        data: cpcAvg,
        zIndex: 7,
        color: '#ffc850',
        marker: {
          lineWidth: 0,
          radius: 0,
          symbol: 'circle',
          lineColor: 'transparent'
        },
        zoneAxis: 'x',
        zones: [{
          value: 2010,
          color: 'transparent'
        }]
      },{
        name: cpcRangeText,
        data: cpcRange,
        type: 'areasplinerange',
        lineWidth: 0,
        linkedTo: ':previous',
        color: '#ffc850',
        lineColor: '#ffc850',
        fillOpacity: 0.3,
        zIndex: 2
      },{
        name: epcAverageText,
        data: epcAvg,
        zIndex: 6,
        color: '#8bced7',
        marker: {
          lineWidth: 0,
          radius: 0,
          symbol: 'circle',
          lineColor: 'transparent'
        },
        zoneAxis: 'x',
        zones: [{
          value: 2010,
          color: 'transparent'
        }]
      },{
        name: epcRangeText,
        data: epcRange,
        type: 'areasplinerange',
        lineWidth: 0,
        linkedTo: ':previous',
        color: '#8bced7',
        lineColor: '#8bced7',
        fillOpacity: 0.3,
        zIndex: 1
      },{
        name: 'Historical emissions',
        data: histAvg,
        zIndex: 1,
        color: 'transparent',
        marker: {
          lineWidth: 0,
          radius: 0,
          symbol: 'circle',
          lineColor: 'transparent'
        },
        zoneAxis: 'x',
        zones: [{
          value: 2010,
          color: '#000000'
        }]
      }]
    };

    chart = new Highcharts.Chart(chartOptions);

    chart.tooltip.options.formatter = function() {
      var points = this.points || Highcharts.splat(this),
        txt = '';

      txt += '<span class="tooltip-year">' + this.x + '</span><br>';

      if(this.x <= 2010) {
        if(typeof this.point === 'undefined') {
          txt += 'Historical emissions: ' + (this.y/divider).toPrecision(3);
        } else {
          txt += 'Custom pledge: ' + (this.y/divider).toPrecision(3);
        }
      } else {
        if(esign.cache.isAbsolute) {
          Highcharts.each(points, function(p, i){
            var name = p.series.name;
            if(p.point.low && p.point.high) {
              txt += ' [' + (p.point.low/divider).toPrecision(3) + ' ' + unit + ' to ' + (p.point.high/divider).toPrecision(3) + ' ' + unit + ']<br>';
            } else {
              if(name !== cerRangeText && name !== gdrRangeText && name !== capRangeText && name !== cpcRangeText && name !== epcRangeText) {
                txt += name + ': ' + (p.y/divider).toPrecision(3) + ' ' + unit;
              } else {
                txt += ' [' + (p.point.low/divider).toPrecision(3) + ' ' + unit + ' to ' + (p.point.high/divider).toPrecision(3) + ' ' + unit + ']<br>';
              }
            }
          });
        } else {
          Highcharts.each(points, function(p, i){
            var name = p.series.name,
              avg = p.y,
              low = p.point.low,
              high = p.point.high;

            if(avg) {
              if(avg > 999) {
                avg = Math.round(avg);
              } else {
                avg = avg.toPrecision(3);
              }
            }
            if(low) {
              if(low > 999) {
                low = Math.round(low);
              } else {
                low = low.toPrecision(3);
              }
            }
            if(high) {
              if(high > 999) {
                high = Math.round(high);
              } else {
                high = high.toPrecision(3);
              }
            }
            if(p.point.low && p.point.high) {
              txt += ' [' + low + '% to ' + high + '%]<br>';
            } else {
              if(name !== cerRangeText && name !== gdrRangeText && name !== capRangeText && name !== cpcRangeText && name !== epcRangeText) {
                txt += name + ': ' + avg + '%';
              } else {
                txt += ' [' + low + '% to ' + high + '%]<br>';
              }
            }
          });
        }
      }
      return txt;
    };

    // NDC dot
    if(esign.cache.isAbsolute) {
      indcData = [
        [2030, indcAbs]
      ];
    } else {
      indcData = [
        [2030, indcRel]
      ];
    }

    chart.addSeries({
      name: 'NDC',
      data: indcData,
      type: 'scatter',
      zIndex: 999,
      marker: {
        symbol:
          "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAR5JREFUeNqUVFEVwjAMzDBAJcwBkzApk1AJSEDCJFTCJBQHkxAHI4UGjpBuj7x3H22aa5JrQ9u2kYXYIJgFWbAByvom6N04QxIEyRC0UEgDxneVhLquK9ksgjN97F7J9aJRcDH+UTj4uYKMGG5dmqW8CLMpPbzLNKXNHonTDiS8aoUDZnREZAhXiC3rp2q60Tuqplr27PgniI0E6WaHiI2CbBWEM+kE6iz0bdEoS3UdzV5WtU+wyeZQT38akgXjWxsxvEfY6lnv9Czv9Yzqt9DDoyP/tSI6RKjmpBk0bz54Z4wqq+P2D6HzAyJ+J+sszZ8aRJPpZfoZQQ6hpr8ArCAJq6BGw49mGWtp7jxDk9kWajmjeX9cs0nvGQb2EGAAfgvEdC8IS/gAAAAASUVORK5CYII=)"
        //"url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOdJREFUeNqsVG0RwyAMBRRUAg42CZVQCZVQCZNQCcwBEjoHzEEl1EGX7ODuLYWuP5K7d1CaPBLyYfd9N1KstZ6WIaMj3AgvwkaIDLLbDoZMVpANZz7+Ayaa0PZrL4jSBSJEOJA1iFa+ndATfF7n7FWVsJDJ0B4yBBFBFPpjeXt/lUiQIuFayNCrVPFi5As4s5V/GDJn3izS3ZN3DIIQHZmNUPagODUyeAedAc4XJ2puhc/O1GWA/U/hukrlVxVBYutCl9ukSA/7QHgLoid5nxr6ST2benWm2gHqvak6NbTmmdWctB8BBgBtMbCsf1XVtQAAAABJRU5ErkJggg==)"
        ,
        lineWidth: 2,
        radius: 8,
        lineColor: 'black',
        fillColor: 'black'
      },
      className: 'indc-tour',
      showInLegend: false
    });

    //add new pledge
    chart.addSeries({
      visible:false,
      name: 'Custom pledge',
      data: indcData,
      type: 'scatter',
      zIndex: 999,
      marker: {
        symbol: 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAVhJREFUeNqsVMFRwzAQtDX84zc8CBXgDoAKMBUk+fIhqSCmA/sRvjgV4BJCB04FOA/+oQKzN3PJbA7J4xmimR1L8t6etDop7rousu3qbT3GJ1MkwC3wCeyBWvD9PNnbuJjFICKBOfAS9bcf4UGw8Iqp0EZXMbStITg9DFyP0A5YAA/AjX5LXdWhTRBbnawME4XZ2isy5r6laGIReKTpGfhVfLmqxOyvIUJGtCbBHWLGF+jMibNlIV2FnKgkbPCvJq541QIj4BrcTDxLiVAYIfHxHVgCH+yPlkZFsfcidkcTG5PZnqwYngb4qWMmsrU0TAJ2ZdQ/KVznqXwvkVodSuj0mhz3TX3xY+sp0ibAb0SMf86NwUKeSbkAT1ztekBT9u+sdebU9JJ4SxDzHpHECEX6OByvU+huFmpDq4Wb6dZGvst+/lfDGF4OEJGXY8FCfx7H/760vwIMAOeyph8xNs45AAAAAElFTkSuQmCC)'
      },
      className: 'indc-tour',
      showInLegend: false
    });

    var updateCustomPledge = function (year, emission) {
      $(chart.series).each(function(i, serie){
        if(serie.name === 'Custom pledge'){

          if(unit === "GtCO2eq") {
            emission*=1000000;
          }
          if(unit === "MtCO2eq") emission*=1000;

          serie.setData([[year,emission]]);
          serie.show();
        }
      });
    };

    // showPledgeForm
    $('#addPlegde').click(function () {
      $('.customMarker').fadeIn();
      $('#custom-pledge-close').fadeIn();
    });

    $('#custom-pledge-close').click(function () {
      $('.customMarker').fadeOut();
      $('#custom-pledge-close').fadeOut();
    });

    $('#updatePledge').click(function () {
      var year = $('#year');
      var emission = $('#emissions');
      var yearVal = year.val();
      var emissionVal = emission.val();

      if($.isNumeric(year.val()) && $.isNumeric(emission.val())){
        $('.customMarker').fadeOut();
        $('#custom-pledge-close').fadeOut();
        updateCustomPledge(parseFloat(yearVal), parseFloat(emissionVal));
      }
    });

    $('#emissions').keypress(function (event) {
      if (event.keyCode === 13) {
        $('#updatePledge').click();
      }
    });

    // Exports
    esign.resetExportListeners();

    $('#export-chart-print').click(function () {
      chart.print();
    });
    $('#export-chart-png').click(function () {
      chart.exportChartLocal({
        type: 'image/png'
      });
    });
    $('#export-chart-jpg').click(function () {
      chart.exportChartLocal({
        type: 'image/jpeg'
      });
    });
    $('#export-chart-pdf').click(function () {
      chart.exportChartLocal({
        type: 'application/pdf'
      });
    });
    $('#export-chart-svg').click(function () {
      chart.exportChartLocal({
        type: 'image/svg+xml'
      });
    });

    // Show help
    $('#openRead').click(function () {
      $('#how-to-read').fadeIn();
      $('#how-to-read-close').fadeIn();
    });

    $('#how-to-read-close').click(function () {
      $('#how-to-read').fadeOut();
      $('#how-to-read-close').fadeOut();
    });

    $('#openRead2').click(function () {
      $('#how-to-read2').fadeIn();
      $('#how-to-read-close2').fadeIn();
    });

    $('#how-to-read-close2').click(function () {
      $('#how-to-read2').fadeOut();
      $('#how-to-read-close2').fadeOut();
    });

    // Fill table
    if(esign.cache.isAbsolute) {
      $('.unit-2030').html('2030 allocations (in ' + unit + ')');
      $('.unit-2050').html('2050 allocations (in ' + unit + ')');

    } else {
      $('.unit-2030').html('2030 allocations (in % of ' + year + ' levels)');
      $('.unit-2050').html('2050 allocations (in % of ' + year + ' levels)');
    }

    if(esign.cache.isSecond) {
      $('.deg').html('2°C')
    } else {
      $('.deg').html('1.5°C')
    }

    // Data table
    function calc(obj, targetYear, relativeYear, index) {
      var number = (obj[targetYear-relativeYear][index] / divider);
      if(number > 999) {
        number = Math.round(number);
      } else {
        number = number.toPrecision(3);
      }
      return number;
    }

    $('.data-table__2030 .row-cer .avg').html((cerAvg[2030-1990][1] / divider).toPrecision(3));
    $('.data-table__2030 .row-gdr .avg').html((gdrAvg[2030-1990][1] / divider).toPrecision(3));
    $('.data-table__2030 .row-cap .avg').html((capAvg[2030-1990][1] / divider).toPrecision(3));
    $('.data-table__2030 .row-cpc .avg').html((cpcAvg[2030-1990][1] / divider).toPrecision(3));
    $('.data-table__2030 .row-epc .avg').html((epcAvg[2030-1990][1] / divider).toPrecision(3));

    $('.data-table__2050 .row-cer .avg').html((cerAvg[2050-1990][1] / divider).toPrecision(3));
    $('.data-table__2050 .row-gdr .avg').html((gdrAvg[2050-1990][1] / divider).toPrecision(3));
    $('.data-table__2050 .row-cap .avg').html((capAvg[2050-1990][1] / divider).toPrecision(3));
    $('.data-table__2050 .row-cpc .avg').html((cpcAvg[2050-1990][1] / divider).toPrecision(3));
    $('.data-table__2050 .row-epc .avg').html((epcAvg[2050-1990][1] / divider).toPrecision(3));


    if(esign.cache.isAbsolute) {
      $('.data-table__2030 .row-cer .range').html('[' + calc(cerRange, 2030, year-20, 1) + ' to ' + calc(cerRange, 2030, year-20, 2) + ']');
      $('.data-table__2030 .row-gdr .range').html('[' + calc(gdrRange, 2030, year-20, 1) + ' to ' + calc(gdrRange, 2030, year-20, 2) + ']');
      $('.data-table__2030 .row-cap .range').html('[' + calc(capRange, 2030, year-20, 1) + ' to ' + calc(capRange, 2030, year-20, 2) + ']');
      $('.data-table__2030 .row-cpc .range').html('[' + calc(cpcRange, 2030, year-20, 1) + ' to ' + calc(cpcRange, 2030, year-20, 2) + ']');
      $('.data-table__2030 .row-epc .range').html('[' + calc(epcRange, 2030, year-20, 1) + ' to ' + calc(epcRange, 2030, year-20, 2) + ']');

      $('.data-table__2050 .row-cer .range').html('[' + calc(cerRange, 2050, year-20, 1) + ' to ' + calc(cerRange, 2050, year-20, 2) + ']');
      $('.data-table__2050 .row-gdr .range').html('[' + calc(gdrRange, 2050, year-20, 1) + ' to ' + calc(gdrRange, 2050, year-20, 2) + ']');
      $('.data-table__2050 .row-cap .range').html('[' + calc(capRange, 2050, year-20, 1) + ' to ' + calc(capRange, 2050, year-20, 2) + ']');
      $('.data-table__2050 .row-cpc .range').html('[' + calc(cpcRange, 2050, year-20, 1) + ' to ' + calc(cpcRange, 2050, year-20, 2) + ']');
      $('.data-table__2050 .row-epc .range').html('[' + calc(epcRange, 2050, year-20, 1) + ' to ' + calc(epcRange, 2050, year-20, 2) + ']');
    } else {
      $('.data-table__2030 .row-cer .range').html('[' + calc(cerRange, 2030, year, 1) + ' to ' + calc(cerRange, 2030, year, 2) + ']');
      $('.data-table__2030 .row-gdr .range').html('[' + calc(gdrRange, 2030, year, 1) + ' to ' + calc(gdrRange, 2030, year, 2) + ']');
      $('.data-table__2030 .row-cap .range').html('[' + calc(capRange, 2030, year, 1) + ' to ' + calc(capRange, 2030, year, 2) + ']');
      $('.data-table__2030 .row-cpc .range').html('[' + calc(cpcRange, 2030, year, 1) + ' to ' + calc(cpcRange, 2030, year, 2) + ']');
      $('.data-table__2030 .row-epc .range').html('[' + calc(epcRange, 2030, year, 1) + ' to ' + calc(epcRange, 2030, year, 2) + ']');

      $('.data-table__2050 .row-cer .range').html('[' + calc(cerRange, 2050, year, 1) + ' to ' + calc(cerRange, 2050, year, 2) + ']');
      $('.data-table__2050 .row-gdr .range').html('[' + calc(gdrRange, 2050, year, 1) + ' to ' + calc(gdrRange, 2050, year, 2) + ']');
      $('.data-table__2050 .row-cap .range').html('[' + calc(capRange, 2050, year, 1) + ' to ' + calc(capRange, 2050, year, 2) + ']');
      $('.data-table__2050 .row-cpc .range').html('[' + calc(cpcRange, 2050, year, 1) + ' to ' + calc(cpcRange, 2050, year, 2) + ']');
      $('.data-table__2050 .row-epc .range').html('[' + calc(epcRange, 2050, year, 1) + ' to ' + calc(epcRange, 2050, year, 2) + ']');
    }
  }
};

/* Fill fairness statement */
esign.fairnessStatement = function(iso) {
  if (esign.cache.warmingModeUpdated) {
    var fieldsUpdated = ['status', 'date', '6a', '6b', '6c', '6d', '6e', '7a', '7b', 'conditionality', 'comments'];
    var fieldsUpdatedEU27 = ['latest_available', 'source', 'note'];

    $.getJSON('assets/data/fairness-all-updated.json?v=' + esign.cache.version, function(data) {
      try {
        function getCountryIso(value) {
          return value['iso-a3'] === iso;
        }

        var fairnessStatement = data.filter(getCountryIso)[0];


        if (esign.cache.countriesEU27.indexOf(fairnessStatement['iso-a3']) > -1) {
          $('.fairness-statement-updated').addClass('hide');
          $('.fairness-statement-updated-eu27').removeClass('hide');

          for (var i = 0; i < fieldsUpdatedEU27.length; i += 1) {
            $('.description-' + fieldsUpdatedEU27[i]).html(
              fairnessStatement[fieldsUpdatedEU27[i]] && fairnessStatement[fieldsUpdatedEU27[i]].length
                ? fairnessStatement[fieldsUpdatedEU27[i]] : 'Not Specified'
            );
          }
        } else {
          $('.fairness-statement-updated').removeClass('hide');
          $('.fairness-statement-updated-eu27').addClass('hide');

          for (var i = 0; i < fieldsUpdated.length; i += 1) {
            $('.description-' + fieldsUpdated[i]).html(
              fairnessStatement[fieldsUpdated[i]] && fairnessStatement[fieldsUpdated[i]].length
                ? fairnessStatement[fieldsUpdated[i]] : 'Not Specified'
            );
          }
        }

        $('.fairness-statement-credits').addClass('hide');
      } catch(e) {
        $('.fairness-statement-updated').removeClass('hide');
        $('.fairness-statement-updated-eu27').addClass('hide');

        for (var i = 0; i < fieldsUpdatedEU27.length; i += 1) {
          $('.description-' + fieldsUpdatedEU27[i]).html('Not Specified');
        }
        for (var i = 0; i < fieldsUpdated.length; i += 1) {
          $('.description-' + fieldsUpdated[i]).html('Not Specified');
        }

        $('.fairness-statement-credits').addClass('hide');
      }
    });
  } else {
    $.getJSON('assets/data/fairness-all.json?v=' + esign.cache.version, function(data) {
      try {
        function getCountryIso(value) {
          return value['iso-a3'] === iso;
        }
        var fairnessStatement = data.filter(getCountryIso);
        $('.description-f').html(fairnessStatement[0]['Description of fairness']);
        $('.description-a').html(fairnessStatement[0]['Description of ambition']);
        $('.description-c').html(fairnessStatement[0]['Description of how it contributes towards achieving the objective of the Convention']);
        $('.description-indc').html(fairnessStatement[0]['Conditionality of the NDC']);
        $('.description-updated').html(fairnessStatement[0]['Last updated (in the Module)']);
        $('.fairness-statement-credits').removeClass('hide');
      } catch(e) {
        $('.description-f').html('Not Specified');
        $('.description-a').html('Not Specified');
        $('.description-c').html('Not Specified');
        $('.description-indc').html('Not Specified');
        $('.description-updated').html('Not Specified');
        $('.fairness-statement-credits').removeClass('hide');
      }
    });
  }
};

/* Qtip */
esign.qtip = function () {
  if(!esign.cache.isMobile) {
    addStarTooltip($('.tooltip--cer'), 'Constant Emissions Ratio', 'Maintains current national emissions ratios. All countries mitigate at the same rate.');
    addStarTooltip($('.tooltip--gdr'), 'Greenhouse Development Rights', 'Rich countries with high historical per capita emissions should reduce emissions the most, other countries\' emissions can temporarily increase.');
    addStarTooltip($('.tooltip--cap'), 'Capability', 'Rich countries should reduce emissions the most, other countries\' emissions can temporarily increase.');
    addStarTooltip($('.tooltip--cpc'), 'Equal Cumulative Per Capita', 'Countries with high historical per capita emissions should reduce emissions more the future.');
    addStarTooltip($('.tooltip--epc'), 'Equal Per Capita', 'All countries converge to equal per capita emissions.');
    $('.indc-tip').qtip({
      content: {
        text: "NDCs – Nationally Determined Contributions - are climate action plans that were submitted to the UNFCCC during the lead-up to the Paris Agreement in 2015."
      },
      position: {
        my: 'bottom center',
        at: 'top center'
      }
    });
    $('.grading-tip').qtip({
      content: {
        text: "The number of stars given to each country corresponds to the number of visions of equity met by its Nationally Determined Contribution. A country with a higher number of stars can be considered ambitious according to more visions of equity, and is therefore likely to be considered ambitious by a greater number of countries. However, it would not appear ambitious according to the visions of equity that are not matched, and as such could not be considered as universally ambitious."
      },
      position: {
        my: 'bottom left',
        at: 'top center'
      }
    });
  }

  function addStarTooltip(selector, title, text) {
    selector.qtip({
      content: {
        title: title,
        text: text
      },
      position: {
        my: 'bottom center',
        at: 'top center'
      }
    });
  }
};

/* Reset map, charts & elements */
esign.resetState = function() {
  esign.cache.isoSelected = '';
  esign.cache.countrySelected = '';
  esign.cache.isAbsolute = false;

  esign.cache.$relativeTrigger
    .addClass('active')
    .html('Relative to 2010 <span class="caret"></span><span class="sr-only">Toggle Dropdown</span>');
  esign.cache.$relativeTrigger2
    .addClass('active')
    .html('Relative to 2010 <span class="caret"></span><span class="sr-only">Toggle Dropdown</span>');
  esign.cache.$absoluteTrigger.removeClass('active');
  esign.cache.$absoluteTrigger2.removeClass('active');
  $('#chart').empty();
  $('#chart2').empty();
  $('.how-to-read').css('display', 'none');

  esign.cache.$absoluteTrigger.unbind( "click" );
  esign.cache.$absoluteTrigger2.unbind( "click" );
  $('.rel-year').unbind( "click" );
  $('.read-button').unbind( "click" );
  $('#one-graph').unbind( "click" );
  $('#two-graph').unbind( "click" );
  $('#addPlegde').unbind( "click" );
  $('#custom-pledge-close').unbind( "click" );
  $('#updatePledge').unbind( "click" );
  $('#openRead').unbind( "click" );
  $('#openRead2').unbind( "click" );
  $('#how-to-read-close').unbind( "click" );
  $('#how-to-read-close2').unbind( "click" );

  esign.resetExportListeners();
};

/* Unbind export listeners */
esign.resetExportListeners = function() {
  $('#export-chart-print').unbind( "click" );
  $('#export-chart-png').unbind( "click" );
  $('#export-chart-jpg').unbind( "click" );
  $('#export-chart-pdf').unbind( "click" );
  $('#export-chart-svg').unbind( "click" );
};

esign.resetExportListeners2 = function() {
  $('#export-chart-print2').unbind( "click" );
  $('#export-chart-png2').unbind( "click" );
  $('#export-chart-jpg2').unbind( "click" );
  $('#export-chart-pdf2').unbind( "click" );
  $('#export-chart-svg2').unbind( "click" );
};


/***********************************
 * Warming Map
 ***********************************/
esign.warmingMap = function() {
  esign.resetState();
  esign.cache.warmingMode = 2;
  esign.loadWarmingMapData();

  var $temperatureToggle = $('.temperature-toggle');
  var $temperatureToggleUpdated = $('.temperature-toggle-updated');
  var $temperatureToggleSource = $('.temperature-toggle-source');
  var $triggerLow = $('#low');
  var $triggerAvg = $('#avg');
  var $triggerHigh = $('#high');
  var $triggerLowUpdated = $('#low-updated');
  var $triggerHighUpdated = $('#high-updated');
  var $triggerFirst = $('#first-ndc');
  var $triggerUpdated = $('#updated-ndc');
  var $triggerFirstGraph = $('#first-ndc-graph');
  var $triggerUpdatedGraph = $('#updated-ndc-graph');
  var $triggerSource1 = $('#climate-action-tracker');
  var $triggerSource2 = $('#meinshausen');
  var $triggerSource3 = $('#national-eu-targets');
  var $fairnessFirst = $('.fairness-statement-first');
  var $fairnessUpdated = $('.fairness-statement-updated');

  // Low
  $triggerLow.click(function (e) {
    e.preventDefault();

    if (esign.cache.warmingMode !== 2) {
      esign.resetState();
      esign.cache.warmingMode = 2;
      $triggerAvg.removeClass('active');
      $triggerHigh.removeClass('active');
      $triggerLow.addClass('active');

      $('#two-graph').removeClass('active');
      $('#one-graph').addClass('active');
      esign.loadWarmingMapData();
    }
  });

  // Avg
  $triggerAvg.click(function (e) {
    e.preventDefault();

    if (esign.cache.warmingMode !== 0) {
      esign.resetState();
      esign.cache.warmingMode = 0;
      $triggerHigh.removeClass('active');
      $triggerLow.removeClass('active');
      $triggerAvg.addClass('active');

      $('#one-graph').removeClass('active');
      $('#two-graph').addClass('active');
      esign.loadWarmingMapData();
    }
  });

  // High
  $triggerHigh.click(function (e) {
    e.preventDefault();

    if (esign.cache.warmingMode !== 1) {
      esign.resetState();
      esign.cache.warmingMode = 1;
      $triggerLow.removeClass('active');
      $triggerAvg.removeClass('active');
      $triggerHigh.addClass('active');

      $('#one-graph').removeClass('active');
      $('#two-graph').addClass('active');
      esign.loadWarmingMapData();
    }
  });

  // Low updated
  $triggerLowUpdated.click(function (e) {
    e.preventDefault();

    if (esign.cache.warmingMode !== 2) {
      esign.resetState();
      esign.cache.warmingMode = 2;
      $triggerHighUpdated.removeClass('active');
      $triggerLowUpdated.addClass('active');

      $('#two-graph').removeClass('active');
      $('#one-graph').addClass('active');
      esign.loadWarmingMapData();
    }
  });

  // High updated
  $triggerHighUpdated.click(function (e) {
    e.preventDefault();

    if (esign.cache.warmingMode !== 1) {
      esign.resetState();
      esign.cache.warmingMode = 1;
      $triggerLowUpdated.removeClass('active');
      $triggerHighUpdated.addClass('active');

      $('#one-graph').removeClass('active');
      $('#two-graph').addClass('active');
      esign.loadWarmingMapData();
    }
  });

  // First NDC
  $triggerFirst.click(function (e) {
    e.preventDefault();

    if (esign.cache.warmingModeUpdated !== false && !$triggerFirst.hasClass('active')) {
      esign.resetState();
      esign.cache.warmingModeUpdated = false;
      esign.cache.warmingMode = 2;
      $temperatureToggle.removeClass('hide');
      $temperatureToggleUpdated.addClass('hide');
      $temperatureToggleSource.addClass('hide');
      $triggerUpdated.removeClass('active');
      $triggerFirst.addClass('active');
      $triggerUpdatedGraph.removeClass('active');
      $triggerFirstGraph.addClass('active');
      $triggerLow.addClass('active');
      $triggerHigh.removeClass('active');
      $triggerAvg.removeClass('active');
      esign.loadWarmingMapData();
      esign.checkListVisibleCountries();
      $fairnessFirst.removeClass('hide');
      $fairnessUpdated.addClass('hide');
    }
  });

  // Updated NDC
  $triggerUpdated.click(function (e) {
    e.preventDefault();
    if (esign.cache.warmingModeUpdated !== true && !$triggerUpdated.hasClass('active')) {
      esign.resetState();
      esign.cache.warmingModeUpdated = true;
      esign.cache.warmingMode = 2;
      esign.cache.warmingSource = 1;
      $temperatureToggle.addClass('hide');
      $temperatureToggleUpdated.removeClass('hide');
      $temperatureToggleSource.removeClass('hide');
      $triggerFirst.removeClass('active');
      $triggerUpdated.addClass('active');
      $triggerFirstGraph.removeClass('active');
      $triggerUpdatedGraph.addClass('active');
      $triggerSource2.addClass('active');
      $triggerSource1.removeClass('active');
      $triggerSource3.removeClass('active');
      $triggerLowUpdated.addClass('active');
      $triggerHighUpdated.removeClass('active');
      esign.loadWarmingMapData();
      esign.checkListVisibleCountries();
      $fairnessFirst.addClass('hide');
      $fairnessUpdated.removeClass('hide');
    }
  });

  // Climate Action Tracker
  $triggerSource1.click(function (e) {
    e.preventDefault();
    if (!$triggerSource1.hasClass('active')) {
      esign.resetState();
      esign.cache.warmingSource = 0;
      $triggerSource2.removeClass('active');
      $triggerSource3.removeClass('active');
      $triggerSource1.addClass('active');
      esign.loadWarmingMapData();
    }
  });

  // Meinshausen
  $triggerSource2.click(function (e) {
    e.preventDefault();
    if (!$triggerSource2.hasClass('active')) {
      esign.resetState();
      esign.cache.warmingSource = 1;
      $triggerSource1.removeClass('active');
      $triggerSource3.removeClass('active');
      $triggerSource2.addClass('active');
      esign.loadWarmingMapData();
    }
  });

  // National EU targets
  $triggerSource3.click(function (e) {
    e.preventDefault();
    if (!$triggerSource3.hasClass('active')) {
      esign.resetState();
      esign.cache.warmingSource = 2;
      $triggerSource1.removeClass('active');
      $triggerSource2.removeClass('active');
      $triggerSource3.addClass('active');
      esign.loadWarmingMapData();
    }
  });
};

esign.replaceEUValues = function(dataName, dataNameEU27 = null, dataNameEU28 = null) {
  var EU27 = esign.getValueByIso(esign.cache[dataName], 'EU27');
  var EU28 = esign.getValueByIso(esign.cache[dataName], 'EU28');

  for (var i = 0; i < esign.cache[dataName].length; i += 1) {
    if (dataNameEU27) {
      if (esign.cache.countriesEU27.indexOf(esign.cache[dataName][i]['iso-a3']) > -1) {
        esign.cache[dataNameEU27].push({
          'iso-a3': esign.cache[dataName][i]['iso-a3'],
          value: EU27.value
        });
      } else {
        esign.cache[dataNameEU27].push(esign.cache[dataName][i]);
      }
    }

    if (dataNameEU28) {
      if (esign.cache.countriesEU28.indexOf(esign.cache[dataName][i]['iso-a3']) > -1) {
        esign.cache[dataNameEU28].push({
          'iso-a3': esign.cache[dataName][i]['iso-a3'],
          value: EU28.value
        });
      } else {
        esign.cache[dataNameEU28].push(esign.cache[dataName][i]);
      }
    }
  }
}

esign.closest = function(needle, haystack) {
  return haystack.reduce((a, b) => {
    let aDiff = Math.abs(a - needle);
    let bDiff = Math.abs(b - needle);

    if (aDiff === bDiff) {
      return a > b ? a : b;
    } else {
      return bDiff < aDiff ? b : a;
    }
  });
}

esign.loadWarmingMapDataMeinshausen = function() {
  var pathX = 'assets/data/warming_consistency_x.json?v=' + esign.cache.version;
  var pathY = 'assets/data/warming_consistency_y.json?v=' + esign.cache.version;
  var pathDataMeinshausen = 'assets/data/warming_consistency_meinshausen.json?v=' + esign.cache.version;

  $.when(
    $.getJSON(pathDataMeinshausen, function(data) {
      esign.cache.warmingConsistencyDataMeinshausen = data;
    }),
    $.getJSON(pathX, function(data) {
      esign.cache.warmingConsistencyX = data;
    }),
    $.getJSON(pathY, function(data) {
      esign.cache.warmingConsistencyY = data;
    }),
    $.getJSON('assets/data/warming_low_meinshausen.json?v=' + esign.cache.version, function(dataMap) {
      esign.cache.warmingLowMeinshausen = dataMap;
    }),
    $.getJSON('assets/data/warming_high_meinshausen.json?v=' + esign.cache.version, function(dataMap) {
      esign.cache.warmingHighMeinshausen = dataMap;
    }),
  ).done(setMeinshausenValues);

  function setMeinshausenValues() {
    $.when(
      (function () {
        var keys = ['r', 'g', 'b', 'temp-avg-x', 'em-avg-y', 'temp-high-x', 'em-high-y', 'temp-low-x', 'em-low-y', 'em-high-y-min', 'em-high-y-max', 'em-low-y-min', 'em-low-y-max'];
        var xAxis = esign.cache.warmingConsistencyX[0].x;

        esign.cache.warmingConsistencyDataMeinshausen.forEach(function(item) {
          var consistency = esign.cache.warmingConsistencyY.filter(function(value) {
            return Object.keys(value)[0] === item['iso-a3'];
          })[0];
          var low = esign.cache.warmingLowMeinshausen.filter(function(value) {
            return value['iso-a3'] === item['iso-a3'];
          })[0];
          var high = esign.cache.warmingHighMeinshausen.filter(function(value) {
            return value['iso-a3'] === item['iso-a3'];
          })[0];

          if (consistency) {
            consistency = consistency[item['iso-a3']];
          }

          for (var i = 0; i < keys.length; i++) {
            if (typeof item[keys[i]] === 'string') {
              if (item[keys[i]]) {
                item[keys[i]] = item[keys[i]].replace(',','.');
                item[keys[i]] = parseFloat(item[keys[i]]);

                if (consistency) {
                  if (keys[i].indexOf('-y') > -1) {
                    item[keys[i]] = esign.closest(item[keys[i]], consistency);
                  }
                }
              }
            }
          }

          if (consistency) {
            item['temp-avg-x'] = xAxis[consistency.indexOf(item['em-avg-y'])];
            item['temp-high-x'] = xAxis[consistency.indexOf(item['em-high-y'])];
            item['temp-low-x'] = xAxis[consistency.indexOf(item['em-low-y'])];

            if (item['temp-high-x']) {
              high.value = Math.round(item['temp-high-x'] * 10) / 10;
            }

            if (item['temp-low-x']) {
              low.value =  Math.round(item['temp-low-x'] * 10) / 10;
            }
          }
        });

        esign.replaceEUValues('warmingLowMeinshausen', 'warmingLowMeinshausenEU27');
        esign.replaceEUValues('warmingHighMeinshausen', 'warmingHighMeinshausenEU27');
      })(),
    ).done(function() {
      esign.loadWarmingMapData();
    });
  }
};

esign.loadWarmingMapDataNationalEUTargets = function() {
  var pathX = 'assets/data/warming_consistency_x.json?v=' + esign.cache.version;
  var pathY = 'assets/data/warming_consistency_y.json?v=' + esign.cache.version;
  var pathDataNationalEUTargets = 'assets/data/warming_consistency_national_eu_targets.json?v=' + esign.cache.version;

  $.when(
    $.getJSON(pathDataNationalEUTargets, function(data) {
      esign.cache.warmingConsistencyDataNationalEUTargets = data;
    }),
    $.getJSON(pathX, function(data) {
      esign.cache.warmingConsistencyX = data;
    }),
    $.getJSON(pathY, function(data) {
      esign.cache.warmingConsistencyY = data;
    }),
    $.getJSON('assets/data/warming_low_national_eu_targets.json?v=' + esign.cache.version, function(dataMap) {
      esign.cache.warmingLowNationalEUTargets = dataMap;
    }),
    $.getJSON('assets/data/warming_high_national_eu_targets.json?v=' + esign.cache.version, function(dataMap) {
      esign.cache.warmingHighNationalEUTargets = dataMap;
    }),
  ).done(setNationalEUTargetsValues);

  function setNationalEUTargetsValues() {
    $.when(
      (function () {
        var keys = ['r', 'g', 'b', 'temp-avg-x', 'em-avg-y', 'temp-high-x', 'em-high-y', 'temp-low-x', 'em-low-y', 'em-high-y-min', 'em-high-y-max', 'em-low-y-min', 'em-low-y-max'];
        var xAxis = esign.cache.warmingConsistencyX[0].x;

        esign.cache.warmingConsistencyDataNationalEUTargets.forEach(function(item) {
          var consistency = esign.cache.warmingConsistencyY.filter(function(value) {
            return Object.keys(value)[0] === item['iso-a3'];
          })[0];
          var low = esign.cache.warmingLowNationalEUTargets.filter(function(value) {
            return value['iso-a3'] === item['iso-a3'];
          })[0];
          var high = esign.cache.warmingHighNationalEUTargets.filter(function(value) {
            return value['iso-a3'] === item['iso-a3'];
          })[0];

          if (consistency) {
            consistency = consistency[item['iso-a3']];
          }

          for (var i = 0; i < keys.length; i++) {
            if (typeof item[keys[i]] === 'string') {
              if (item[keys[i]]) {
                item[keys[i]] = item[keys[i]].replace(',','.');
                item[keys[i]] = parseFloat(item[keys[i]]);

                if (consistency) {
                  if (keys[i].indexOf('-y') > -1) {
                    item[keys[i]] = esign.closest(item[keys[i]], consistency);
                  }
                }
              }
            }
          }

          if (consistency) {
            item['temp-avg-x'] = xAxis[consistency.indexOf(item['em-avg-y'])];
            item['temp-high-x'] = xAxis[consistency.indexOf(item['em-high-y'])];
            item['temp-low-x'] = xAxis[consistency.indexOf(item['em-low-y'])];

            if (item['temp-high-x']) {
              high.value = Math.round(item['temp-high-x'] * 10) / 10;
            }

            if (item['temp-low-x']) {
              low.value =  Math.round(item['temp-low-x'] * 10) / 10;
            }
          }
        });

        esign.cache.warmingLowNationalEUTargetsEU27 = esign.cache.warmingLowNationalEUTargets;
        esign.cache.warmingHighNationalEUTargetsEU27 = esign.cache.warmingHighNationalEUTargets;
      })(),
    ).done(function() {
      esign.loadWarmingMapData();
    });
  }
};

/* Load warming map data */
esign.loadWarmingMapData = function() {
  esign.cache.filenameMap = 'Global 2100-warming of NDCs [Downloaded from Paris-equity-check.org]';

  if (
    (esign.cache.warmingModeUpdated && esign.cache.warmingSource === 1)
    && (!esign.cache.warmingConsistencyDataMeinshausen || !esign.cache.warmingConsistencyX || !esign.cache.warmingConsistencyY)
  ) {
    esign.loadWarmingMapDataMeinshausen();
    return;
  }

  if (
    (esign.cache.warmingModeUpdated && esign.cache.warmingSource === 2)
    && (!esign.cache.warmingConsistencyDataNationalEUTargets || !esign.cache.warmingConsistencyX || !esign.cache.warmingConsistencyY)
  ) {
    esign.loadWarmingMapDataNationalEUTargets();
    return;
  }

  function loadWarmingType(type) {
    var dataName = 'warming' + type;
    var dataNameEU27 = 'warming' + type + 'EU27';
    var dataNameEU28 = 'warming' + type + 'EU28';
    var dataNameUpdated = 'warming' + type + 'Updated';
    var dataNameUpdatedEU27 = 'warming' + type + 'UpdatedEU27';
    var dataNameUpdatedEU28 = 'warming' + type + 'UpdatedEU28';
    var dataNameMeinshausenEU27 = 'warming' + type + 'MeinshausenEU27';
    var dataNameNationalEUTargetsEU27 = 'warming' + type + 'NationalEUTargetsEU27';

    var mode = 0;

    if (type === 'High') {
      mode = 1;
    }

    if (type === 'Low') {
      mode = 2;
    }

    if (esign.cache.warmingMode === mode) {
      if (esign.cache.warmingModeUpdated) {
        if (esign.cache.warmingSource === 0) {
          if (!esign.cache[dataNameUpdated]) {
            $.getJSON('assets/data/warming_' + type.toLowerCase() + '_updated.json?v=' + esign.cache.version, function(dataMap) {
              esign.cache[dataNameUpdated] = dataMap;
              esign.replaceEUValues(dataNameUpdated, dataNameUpdatedEU27, dataNameUpdatedEU28);
              esign.drawWarmingMap(esign.cache[dataNameUpdatedEU27], 'EU27');
            });
          } else {
            esign.drawWarmingMap(esign.cache[dataNameUpdatedEU27], 'EU27');
          }
        } else if (esign.cache.warmingSource === 1) {
          esign.drawWarmingMap(esign.cache[dataNameMeinshausenEU27], 'EU27');
        } else if (esign.cache.warmingSource === 2) {
          esign.drawWarmingMap(esign.cache[dataNameNationalEUTargetsEU27], 'EU27');
        }
      } else {
        if (!esign.cache[dataName]) {
          $.getJSON('assets/data/warming_' + type.toLowerCase() + '.json?v=' + esign.cache.version, function(dataMap) {
            esign.cache[dataName] = dataMap;
            esign.replaceEUValues(dataName, dataNameEU27, dataNameEU28);
            esign.drawWarmingMap(esign.cache[dataNameEU28], 'EU28');
          });
        } else {
          esign.drawWarmingMap(esign.cache[dataNameEU28], 'EU28');
        }
      }
    }
  }

  loadWarmingType('Avg');
  loadWarmingType('High');
  loadWarmingType('Low');
};

/* Draw map, data of each single country must be in the 1.2-5.1 range to maintain correct color coding */
esign.drawWarmingMap = function(data, seriesName) {
  // Allow nullInteraction fix
  Highcharts.seriesTypes.map.prototype.pointClass.prototype.onMouseOver = function (e) {
    clearTimeout(this.colorInterval);
    if (this.value !== null || this.series.options.nullInteraction) {
      Highcharts.Point.prototype.onMouseOver.call(this, e);
    } else {
      this.series.onMouseOut(e);
    }
  }

  var seriesOptions = function (seriesData, seriesName) {
    return {
      name: seriesName,
      data: seriesData,
      mapData: Highcharts.geojson(Highcharts.maps['custom/world-eckert3-highres']),
      backgroundColor: '#FCFFC5',
      joinBy: 'iso-a3',
      cursor: 'pointer',
      nullInteraction: esign.cache.warmingModeUpdated,
      states: {
        hover: {
          borderColor: 'grey',
          color: this.color
        }
      },
      dataLabels: {
        enabled: false,
        useHTML: true
      },
      point: {
        events:{
          click: function (event) {
            esign.cache.dataSelected = true;
            esign.cache.isoSelected = this['iso-a3'];

            if (this.series && this.series.name && this.series.name === 'EU27' && esign.cache.countriesEU27.indexOf(esign.cache.isoSelected) > -1 && esign.cache.warmingSource !== 2) {
              esign.cache.isoSelected = 'EU27';

            } else if (this.series && this.series.name && this.series.name === 'EU28' && esign.cache.countriesEU28.indexOf(esign.cache.isoSelected) > -1 && esign.cache.warmingSource !== 2) {
              esign.cache.isoSelected = 'EU28';
            }

            for (var i = 0; i < esign.cache.countries.length; i++ ) {
              if(esign.cache.countries[i]['iso-a3'] === esign.cache.isoSelected) esign.cache.countrySelected = esign.cache.countries[i]['country'];
            }

            if (event.point) {
              if (event.point.options && !event.point.options.labelrank) {
                esign.openWarmingChart(this.color, temperatureDisplayValue(this.options.value));
              }
            } else {
              esign.openWarmingChart(this.color, temperatureDisplayValue(this.options.value));
            }
          },
          mouseOver: function (event) {
            if (event.target && event.target.options && !event.target.options.labelrank) {
              event.target.graphic.element.classList.remove('highcharts-null-point')
            }
          },
          mouseOut: function () {

          }
        }
      },
      nullColor: '#F1F1F1',
      borderColor: '#D2D2D2',
      borderWidth: 1
    };
  }

  esign.cache.map = new Highcharts.Map('map2', {
    title: {
      text: esign.cache.filenameMap,
      style: {
        fontSize: '8'
      },
      useHTML: true
    },
    exporting: {
      enabled: false,
      filename: esign.cache.filenameMap,
      fallbackToExportServer: true,
      chartOptions: {
        credits: {
          enabled: true,
          href:"#",
          position: {
            align:"right",
            verticalAlign:"bottom",
            x: -10,
            y: -5
          },
          style: {"cursor": "default", "font-size":"6pt"},
          text:"From Paris-equity-check.org, based on Robiou du Pont et al. (2018), Nature Communications"
        },
        chart:{
          events: {
            load: function(event) {
              this.renderer.image('assets/images/legend-warming.png',10,260,100,129).add();
            }
          }
        }
      }
    },
    chart: {
      margin: [0, 0, 0, 0],
      style: {
        fontFamily: 'Open Sans'
      },
      backgroundColor: '#f6faff',
      pinchType: 'none',
    },
    credits: false,
    mapNavigation: {
      enabled: true,
      enableMouseWheelZoom: false,
      enableDoubleClickZoom: false,
      enableDoubleClickZoomTo: false,
      buttonOptions: {
        align: 'right',
        verticalAlign: 'bottom',
        x: -20,
        theme: {
          fill: 'white',
          'stroke-width': 1,
          stroke: 'silver',
          r: 0,
          states: {
            hover: {
              fill: '#f5f5f5'
            }
          }
        }
      },
      buttons: {
        zoomIn: {
          y: -20
        },
        zoomOut: {
          y: 8
        }
      }
    },
    colorAxis: {
      stops: [
        [0.1, '#74AB00'],
        [0.2, '#E1E000'],
        [0.3, '#E19300'],
        [0.5, '#BF5700'],
        [0.6, '#BF0000'],
        [0.8, '#6E0000']
      ]
    },
    legend: {
      enabled: false,
      align: 'center',
      x: 0,
      y: 10,
      color: '#fff',
      layout: 'horizontal',
      floating: false,
      verticalAlign: 'bottom',
      shadow: false,
      border: 0,
      borderRadius: 0,
      borderWidth: 0
    },
    tooltip: {
      enabled: !esign.cache.isMobile,
      useHTML: true,
      borderWidth:0,
      borderRadius:0,
      padding: 5,
      minWidth: 300,
      backgroundColor: false,
      shadow: false,
      hideDelay: 30,
      formatter: function () {
        var iso = this.point['iso-a3'],
          name;

        for (var i = 0; i < esign.cache.countries.length; i++) {
          if(esign.cache.countries[i]['iso-a3'] === iso) {
            name = esign.cache.countries[i]['country'];
            break;
          }
        }

        if (name === undefined) {
          return false;
        }

        if (esign.cache.warmingModeUpdated && esign.cache.warmingNonAssessedUpdatedTargets.indexOf(iso) > -1) {
          return '<div class="tool"><h4>' + name
            + '</h4><p style="margin-bottom: 5px;"><a href="https://unfccc.int/NDCREG" target="_blank" rel="noopener">Target updated but not assessed here</a></p><div class="approach">' + temperatureDisplayValue(this.point.options.value) + '</div>'
            + '</div>';
        }

        if (iso === 'EU27' || iso === 'EU28') {
          return '<div class="tool"><h4>' + name
            + '</h4><div class="approach">' + temperatureDisplayValue(this.point.options.value) + '</div>'
            + '</div>';
        } else if (this.series && this.series.name && this.series.name === 'EU27' && esign.cache.countriesEU27.indexOf(iso) > -1 && esign.cache.warmingSource !== 2) {
          if (esign.cache.warmingSource === 0) {
            return '<div class="tool"><h4>' + 'European Union (27)'
              + '</h4><div class="approach">' + temperatureDisplayValue(this.point.options.value) + '</div>'
              + '</div>';
          }

          var tempCountry = null;
          var tempEU = null;

          if (esign.cache.warmingSource === 0) {
            tempCountry = esign.cache.warmingMode === 2 ? esign.getValueByIso(esign.cache.warmingLowUpdated, iso).value : esign.getValueByIso(esign.cache.warmingHighUpdated, iso).value;
            tempEU = '2.3';
          } else if (esign.cache.warmingSource === 1) {
            tempCountry = esign.cache.warmingMode === 2 ? esign.getValueByIso(esign.cache.warmingLowMeinshausen, iso).value : esign.getValueByIso(esign.cache.warmingHighMeinshausen, iso).value;
            tempEU = esign.cache.warmingMode === 2 ? esign.getValueByIso(esign.cache.warmingLowMeinshausen, 'EU27').value : esign.getValueByIso(esign.cache.warmingHighMeinshausen, 'EU27').value;
          }

          return '<div class="tool"><h4>' + 'European Union (27)'
            + '</h4><div class="approach">' + tempEU + ' °C </div><hr>'
            + '<h4>' + name
            + '</h4><p style="margin-bottom: 5px;">Select in country list to look at individual EU member state</p><div class="approach">' + temperatureDisplayValue(tempCountry) + '</div></div></div>';
        } else if (this.series && this.series.name && this.series.name === 'EU28' && esign.cache.countriesEU28.indexOf(iso) > -1 && esign.cache.warmingSource !== 2) {
          var temp = null;

          if (esign.cache.warmingMode === 0) {
            temp = esign.getValueByIso(esign.cache.warmingAvg, iso).value;
          }

          if (esign.cache.warmingMode === 1) {
            temp = esign.getValueByIso(esign.cache.warmingHigh, iso).value;
          }

          if (esign.cache.warmingMode === 2) {
            temp = esign.getValueByIso(esign.cache.warmingLow, iso).value;
          }

          return '<div class="tool"><h4>' + 'European Union (28)'
            + '</h4><div class="approach">' + '3.2 °C' + '</div><hr>'
            + '<h4>' + name
            + '</h4><p style="margin-bottom: 5px;">Select in country list to look at individual EU member state</p><div class="approach">' + temperatureDisplayValue(temp) + '</div></div></div>';
        } else {
          return '<div class="tool"><h4>' + name
            + '</h4><div class="approach">' + temperatureDisplayValue(this.point.options.value) + '</div></div>';
        }
      }
    },
    series: [seriesOptions(data, seriesName)]
  });

  function temperatureDisplayValue(value) {
    var ndc;
    var offLimit = '';

    value != null ? ndc = value : ndc = 'N/A';

    if (ndc === 5.1 || ndc > 5.1) {
      offLimit = '&ge; ';
      ndc = 5.1;
    } else if (ndc === 1.2 || ndc < 1.2) {
      offLimit = '&le; ';
      ndc = 1.2;
    }

    if (ndc === 'N/A') {
      return ndc;
    }

    return offLimit + ndc + '°C';
  }

  // Listeners
  var countryListItem = $('#country-list ul li'),
    tooltip, iso;

  countryListItem.click(function (event) {
    esign.cache.dataSelected = true;
    iso = this.getAttribute('data-iso');
    if(esign.cache.isoSelected !== iso) {
      for(var i = 0; i < esign.cache.map.series[0].data.length; i++) {
        if(esign.cache.map.series[0].data[i]['iso-a3'] === iso) {
          tooltip = esign.cache.map.series[0].data[i];
          tooltip.firePointEvent('click', event);
        }
      }
    }
  });

  countryListItem.mouseenter(function () {
    if(!esign.cache.isMobile) {
      iso = this.getAttribute('data-iso');

      if (esign.cache.warmingModeUpdated) {
        if (esign.cache.warmingSource === 1) {
          if (iso === 'EU27') {
            esign.handleWarmingDataSeries(seriesOptions, 'EU27');
          } else if (esign.cache.countriesEU27.indexOf(iso) > -1) {
            esign.handleWarmingDataSeries(seriesOptions);
          }
        }
      } else {
        if (iso === 'EU28') {
          esign.handleWarmingDataSeries(seriesOptions, 'EU28');
        } else if (esign.cache.countriesEU28.indexOf(iso) > -1) {
          esign.handleWarmingDataSeries(seriesOptions);
        }
      }

      for(var i = 0; i < esign.cache.map.series[0].data.length; i++) {
        if(esign.cache.map.series[0].data[i]['iso-a3'] === iso) {
          tooltip = esign.cache.map.series[0].data[i];

          if (tooltip && tooltip.setState) {
            tooltip.setState('hover');
          }

          esign.cache.map.tooltip.update({
            positioner: function(val, val2, val3) {
              if (iso === 'EU27' || iso === 'EU28') {
                return { x: this.chart.plotWidth/2, y: this.chart.plotHeight/3 };
              }
              return { x: val3.plotX, y: val3.plotY };
            }
          });

          esign.cache.map.tooltip.refresh(tooltip);
        }
      }
    }
  });

  countryListItem.mouseleave(function () {
    if(!esign.cache.isMobile) {
      var iso = this.getAttribute('data-iso');

      if (esign.cache.warmingModeUpdated) {
        if (esign.cache.countriesEU27.indexOf(iso) > -1 && esign.cache.warmingSource === 1) {
          esign.handleWarmingDataSeries(seriesOptions, 'EU27');
        }
      } else {
        if (esign.cache.countriesEU28.indexOf(iso) > -1) {
          esign.handleWarmingDataSeries(seriesOptions, 'EU28');
        }
      }

      if (esign.cache.map !== undefined) {
        if (tooltip && tooltip.setState) {
          tooltip.setState();
        }
        esign.cache.map.tooltip.hide();
      }
    }
  });

  countryListItem.removeClass('hide')

  if (esign.cache.warmingModeUpdated) {
    if (esign.cache.warmingSource === 0) {
      // Hide EU27 items
      countryListItem.each(function(index, element) {
        var $element = $(element);
        if (esign.cache.countriesEU27.indexOf($element.data('iso')) > -1) {
          $element.addClass('hide');
        }
      });
    }

    if (esign.cache.warmingSource === 2) {
      // Hide EU27 & all other than National EU Targets
      countryListItem.each(function(index, element) {
        if (esign.cache.countriesNationalEUTargets.indexOf($(element).data('iso')) < 0) {
          $(element).addClass('hide');
        }
      });
    }
  }
};

esign.handleWarmingDataSeries = function(seriesOptions, type = '') {
  esign.cache.map.series[0].remove(true);

  if (esign.cache.warmingMode === 0) {
    if (esign.cache.warmingModeUpdated) {
      esign.cache.map.addSeries(seriesOptions(esign.cache['warmingAvgUpdated' + type], '' + type));
    } else {
      esign.cache.map.addSeries(seriesOptions(esign.cache['warmingAvg' + type], '' + type));
    }
  }

  if (esign.cache.warmingMode === 1) {
    if (esign.cache.warmingModeUpdated) {
      if (esign.cache.warmingSource === 0) {
        esign.cache.map.addSeries(seriesOptions(esign.cache['warmingHighUpdated' + type], '' + type));
      } else {
        esign.cache.map.addSeries(seriesOptions(esign.cache['warmingHighMeinshausen' + type], '' + type));
      }
    } else {
      esign.cache.map.addSeries(seriesOptions(esign.cache['warmingHigh' + type], '' + type));
    }
  }

  if (esign.cache.warmingMode === 2) {
    if (esign.cache.warmingModeUpdated) {
      if (esign.cache.warmingSource === 0) {
        esign.cache.map.addSeries(seriesOptions(esign.cache['warmingLowUpdated' + type], '' + type));
      } else {
        esign.cache.map.addSeries(seriesOptions(esign.cache['warmingLowMeinshausen' + type], '' + type));
      }
    } else {
      esign.cache.map.addSeries(seriesOptions(esign.cache['warmingLow' + type], '' + type));
    }
  }
}

/* Open warming chart view */
esign.openWarmingChart = function(color, temperature) {
  var $graphCountryTitle = $('.graph-country__title');
  var $graphCountryTemperature = $('.graph-country__temperature');
  $('.modal-button-graph').trigger('click');
  $graphCountryTitle.text(esign.cache.countrySelected);
  $graphCountryTemperature.html(temperature);

  esign.fairnessStatement(esign.cache.isoSelected);

  if (
    (esign.cache.warmingModeUpdated && !esign.cache.warmingConsistencyDataUpdated)
    || (!esign.cache.warmingModeUpdated && !esign.cache.warmingConsistencyData)
  ) {
    esign.loadWarmingChartData(color);
  } else {
    esign.initWarmingChartEvents(color);
  }
};

/* Load warming chart data */
esign.loadWarmingChartData = function (color) {
  var pathX = 'assets/data/warming_consistency_x.json?v=' + esign.cache.version;
  var pathY = 'assets/data/warming_consistency_y.json?v=' + esign.cache.version;
  var pathTrajectory1 = 'assets/data/trajectories_1p5c.json?v=' + esign.cache.version;
  var pathTrajectory2 = 'assets/data/trajectories_2c.json?v=' + esign.cache.version;
  var pathData = 'assets/data/warming_consistency.json?v=' + esign.cache.version;
  var pathDataUpdated = 'assets/data/warming_consistency_updated.json?v=' + esign.cache.version;

  $.when(
    $.getJSON(pathData, function(data) {
      esign.cache.warmingConsistencyData = data;
    }),
    $.getJSON(pathDataUpdated, function(data) {
      esign.cache.warmingConsistencyDataUpdated = data;
    }),
    $.getJSON(pathX, function(data) {
      esign.cache.warmingConsistencyX = data;
    }),
    $.getJSON(pathY, function(data) {
      esign.cache.warmingConsistencyY = data;
    }),
    $.getJSON(pathTrajectory1, function(data) {
      esign.cache.warmingTrajectory1 = data;
    }),
    $.getJSON(pathTrajectory2, function(data) {
      esign.cache.warmingTrajectory2 = data;
    })
  ).done(function() {
    esign.initWarmingChartEvents(color);
  });
};

/* Init warming chart events */
esign.initWarmingChartEvents = function (color) {
  // Relative to
  $('.controls--w1 .rel-year').click(function (e) {
    e.preventDefault();

    // esign.cache.isAbsolute = false;
    esign.cache.$relativeTrigger.addClass('active');
    // esign.cache.$absoluteTrigger.removeClass('active');

    var year = this.text.replace('rel-', '');
    esign.cache.$relativeTrigger.html('Relative to ' + year + ' <span class="caret"></span><span class="sr-only">Toggle Dropdown</span>');

    esign.createWarmingChart(year, color);
  });

  $('.controls--w2 .rel-year').click(function (e) {
    e.preventDefault();

    esign.cache.isAbsolute = false;
    esign.cache.$relativeTrigger2.addClass('active');
    esign.cache.$absoluteTrigger2.removeClass('active');

    var year = this.text.replace('rel-', '');
    esign.cache.$relativeTrigger2.html('Relative to ' + year + ' <span class="caret"></span><span class="sr-only">Toggle Dropdown</span>');

    esign.createTrajectoryChart(year);
  });

  esign.cache.$absoluteTrigger2.click(function (e) {
    e.preventDefault();

    if (!esign.cache.isAbsolute) {
      esign.cache.isAbsolute = true;
      esign.cache.$relativeTrigger2.removeClass('active');
      esign.cache.$absoluteTrigger2.addClass('active');

      esign.createTrajectoryChart(2010);
    }
  });

  esign.createWarmingChart(2010, color);
  esign.createTrajectoryChart(2010);
}

/* Create warming chart */
esign.createWarmingChart = function(year, color = esign.cache.color.black) {
  var warmingConsistencyData = esign.cache.warmingConsistencyData;

  if (esign.cache.warmingModeUpdated) {
    if (esign.cache.warmingSource === 0) {
      warmingConsistencyData = esign.cache.warmingConsistencyDataUpdated
    } else if (esign.cache.warmingSource === 1) {
      warmingConsistencyData = esign.cache.warmingConsistencyDataMeinshausen;
    } else if (esign.cache.warmingSource === 2) {
      warmingConsistencyData = esign.cache.warmingConsistencyDataNationalEUTargets;
    }
  }

  var countryData = warmingConsistencyData.filter(getCountryIso)[0];

  function getCountryIso(value) {
    return value['iso-a3'] === esign.cache.isoSelected;
  }

  function getCountryIsoTrajectory(value) {
    return value['iso-a3'] === "'" + esign.cache.isoSelected + "'";
  }

  var dataTrajectory = esign.cache.warmingTrajectory1.filter(getCountryIsoTrajectory);

  var colorDark = tinycolor(color).darken(10).toString();
  var colorLight = tinycolor(color).lighten(30).toString();
  var xAxis = esign.cache.warmingConsistencyX[0].x;
  var yAxis;
  var chartData = [];

  var levels2010 = dataTrajectory[0][2010];
  var levelsRel = dataTrajectory[0][year];

  var chart;

  for (var i = 0; i < esign.cache.warmingConsistencyY.length; i++) {
    if (Object.keys(esign.cache.warmingConsistencyY[i])[0] === esign.cache.isoSelected) {
      yAxis = esign.cache.warmingConsistencyY[i][esign.cache.isoSelected];
      break;
    }
  }

  var minX = 1.179476;
  var maxX = 5.119476;
  var levelsCoefficient = levels2010 / levelsRel;

  var chartDotData = [
    [countryData['temp-avg-x'], (countryData['em-avg-y'] + 100) * levelsCoefficient]
  ];

  if (countryData['temp-avg-x'] < minX) {
    chartDotData = [
      [minX, (countryData['em-avg-y'] + 100) * levelsCoefficient]
    ];
  }

  if (countryData['temp-avg-x'] > maxX) {
    chartDotData = [
      [maxX, (countryData['em-avg-y'] + 100) * levelsCoefficient]
    ];
  }

  if (!countryData['em-avg-y']) {
    chartDotData = null;
  }

  if (!countryData['temp-avg-x'] && countryData['em-avg-y']) {
    chartDotData = [
      [xAxis[yAxis.indexOf(countryData['em-avg-y'])], (countryData['em-avg-y'] + 100) * levelsCoefficient]
    ];
  }

  var chartDotHighData = [
    [countryData['temp-high-x'], (countryData['em-high-y'] + 100) * levelsCoefficient]
  ];

  if (countryData['temp-high-x'] < minX) {
    chartDotHighData = [
      [minX, (countryData['em-high-y'] + 100) * levelsCoefficient]
    ];
  }

  if (countryData['temp-high-x'] > maxX) {
    chartDotHighData = [
      [maxX, (countryData['em-high-y'] + 100) * levelsCoefficient]
    ];
  }

  if (!countryData['em-high-y']) {
    chartDotHighData = null;
  }

  if (!countryData['temp-high-x'] && countryData['em-high-y']) {
    chartDotHighData = [
      [xAxis[yAxis.indexOf(countryData['em-high-y'])], (countryData['em-high-y'] + 100) * levelsCoefficient]
    ];
  }

  var chartDotLowData = [
    [countryData['temp-low-x'], (countryData['em-low-y'] + 100) * levelsCoefficient]
  ];

  if (countryData['temp-low-x'] < minX) {
    chartDotLowData = [
      [minX, (countryData['em-low-y'] + 100) * levelsCoefficient]
    ];
  }

  if (countryData['temp-low-x'] > maxX) {
    chartDotLowData = [
      [maxX, (countryData['em-low-y'] + 100) * levelsCoefficient]
    ];
  }

  if (!countryData['em-low-y']) {
    chartDotLowData = null;
  }

  if (!countryData['temp-low-x'] && countryData['em-low-y']) {
    chartDotLowData = [
      [xAxis[yAxis.indexOf(countryData['em-low-y'])], (countryData['em-low-y'] + 100) * levelsCoefficient]
    ];
  }

  // Error bar series
  var chartErrorDataLowData = [
    [
      (countryData['em-low-y-min'] ? (countryData['em-low-y-min'] + 100) * levelsCoefficient : null),
      (countryData['em-low-y-max'] ? (countryData['em-low-y-max']+ 100) * levelsCoefficient : null)
    ]
  ];

  if (!countryData['em-low-y-min'] || !countryData['em-low-y-max']) {
    chartErrorDataLowData = null;
  }

  var chartErrorDataHighData = [
    [
      (countryData['em-high-y-min'] ? (countryData['em-high-y-min'] + 100) * levelsCoefficient : null),
      (countryData['em-high-y-max'] ? (countryData['em-high-y-max']+ 100) * levelsCoefficient : null)
    ]
  ];

  if (!countryData['em-high-y-min'] || !countryData['em-high-y-max']) {
    chartErrorDataHighData = null;
  }

  // console.log('avg', xAxis[yAxis.indexOf(countryData['em-avg-y'])]);
  // console.log('high', xAxis[yAxis.indexOf(countryData['em-high-y'])]);
  // console.log('low', xAxis[yAxis.indexOf(countryData['em-low-y'])]);

  for (var j = 0; j < xAxis.length; j++) {
    var newYValue = (yAxis[j] + 100) * levelsCoefficient;
    chartData.push([xAxis[j], newYValue]);
  }

  var chartOptions = {
    chart: {
      renderTo: 'chart',
      style: {
        fontFamily: 'Open Sans'
      },
      backgroundColor: '#ffffff'
    },
    title: {
      text: esign.cache.countrySelected,
      useHTML: true
    },
    subtitle: {
      text: '',
      style: {
        color: '#B4B4B4',
        fontSize: '5'
      },
      useHTML: true
    },
    xAxis: {
      title: {
        text: '2100-warming in °C (>50% likelihood)',
        style: {
          fontSize: '14px'
        }
      },
      plotLines: [
        {
          color: '#74AB00',
          value: 1.5,
          width: 1,
          label: {
            text: '1.5°C',
            rotation: 270,
            align: 'right',
            x: -8
          }
        },
        {
          color: '#E1E000',
          value: 1.7,
          width: 1,
          label: {
            text: 'well below 2°C',
            rotation: 270,
            align: 'right',
            x: -8
          }
        }
      ]
    },
    yAxis: {
      title: {
        text: 'Emissions allowances in % of ' + year + ' levels',
        style: {
          fontSize: '14px'
        }
      },
      plotLines: [{
        value: 0,
        color: 'black',
        width: 2
      }],
      crosshair: true
    },
    tooltip: {
      crosshairs: true,
      shared: true,
      useHtml: true,
      borderWidth: 0,
      hideDelay: 30,
      style: {
        fontSize: '15px'
      }
    },
    legend: {
      title: {
        text: 'Legend',
        style: {
          fontWeight: 'normal'
        }
      },
      enabled: true,
      layout: 'vertical',
      floating: false,
      align: 'center left',
      itemStyle: {
        fontWeight: 'normal',
        fontSize: '10px'
      },
      itemMarginBottom: 1,
    },
    exporting: {
      enabled: false,
      filename: esign.cache.countrySelected + ' - 2100-warming as a function of national 2030-emissions',
      buttons: {
        contextButton: {
          verticalAlign: 'bottom',
          text: 'export'
        }
      },
      fallbackToExportServer: true,
      chartOptions: {
        credits: {
          enabled: true,
          href: "#",
          position: {
            align: "right",
            verticalAlign: "bottom",
            x: -10,
            y: -190,
          },
          style: {"cursor": "default", "font-size": "6pt"},
          text: "From Paris-equity-check.org, based on Robiou du Pont et al. (2018), Nature Communications"
        }
      }
    },
    credits: false,
    plotOptions: {
      line: {
        events: {
          legendItemClick: function () {
            return false;
          }
        }
      }
    },
    series: [{
      name: 'National emissions change over 2010-2030 as a function of 2100 global warming',
      data: chartData,
      zIndex: 10,
      color: esign.cache.color.black,
      marker: {
        lineWidth: 0,
        radius: 0,
        symbol: 'circle',
        lineColor: 'transparent'
      },
      zoneAxis: 'x'
    }]
  };

  chart = new Highcharts.Chart(chartOptions);

  chart.tooltip.options.formatter = function() {
    var points = this.points || Highcharts.splat(this),
      txt = 'Implied global warming: ',
      temp,
      roundedValue = esign.round(this.x, 1);

    if (
      this.series &&
      (this.series.name === 'NDC average assessment' ||
        this.series.name === 'NDC high assessment (with unconditional pledges)' ||
        this.series.name === 'NDC low assessment (with conditional pledges)')
    ) {
      if (roundedValue >= 5.1) {
        temp = '&ge; 5.1';
      } else if (roundedValue <= 1.2) {
        temp = '&le; 1.2';
      } else {
        temp = roundedValue;
      }
    } else {
      temp = roundedValue;
    }

    txt += '<span class=""><strong>' + esign.decodeHTML(temp) + ' °C</strong></span><br>';

    Highcharts.each(points, function(p, i) {
      if (!p.point.whiskers) {
        txt += 'Emissions level: <strong>' + esign.round(p.y, 0) + '</strong>';
      }
    });

    return txt;
  };

  var lowSeriesName = 'NDC low assessment (with conditional pledges)';
  var highSeriesName = 'NDC high assessment (with unconditional pledges)';

  if (esign.cache.warmingModeUpdated) {
    lowSeriesName = 'NDC unconditional assessment';
    highSeriesName = 'NDC conditional assessment';

    if (esign.cache.isoSelected === 'KOR') {
      lowSeriesName = 'Proposed target (June 2021)';
      highSeriesName = '2020 NDC update';
    }
  }

  chart.addSeries({
    id: 'ndc-high',
    name: highSeriesName,
    data: chartDotHighData,
    type: 'scatter',
    zIndex: 999,
    marker: {
      lineWidth: 1,
      radius: 8,
      lineColor: colorDark,
      fillColor: '#f6faff',
      symbol: 'circle',
      enabled: !!chartDotHighData
    },
    showInLegend: true
  });

  if (chartErrorDataHighData) {
    chart.addSeries({
      name: 'NDC high assessment uncertainty range',
      data: chartErrorDataHighData,
      type: 'errorbar',
      zIndex: 998,
      showInLegend: false,
      linkedTo: 'ndc-high',
      pointStart: chartDotHighData[0][0],
      stemWidth: 2,
      pointWidth: 3
    });
  }

  chart.addSeries({
    id: 'ndc-low',
    name: lowSeriesName,
    data: chartDotLowData,
    type: 'scatter',
    zIndex: 999,
    marker: {
      lineWidth: 1,
      radius: 8,
      lineColor: esign.cache.warmingModeUpdated ? color : colorLight,
      fillColor: esign.cache.warmingModeUpdated ? color : '#f6faff',
      symbol: 'circle',
      enabled: !!chartDotLowData
    },
    showInLegend: true
  });

  if (chartErrorDataLowData) {
    chart.addSeries({
      name: 'NDC low assessment uncertainty range',
      data: chartErrorDataLowData,
      type: 'errorbar',
      zIndex: 998,
      showInLegend: false,
      linkedTo: 'ndc-low',
      pointStart: chartDotLowData[0][0],
      stemWidth: 2,
      pointWidth: 3
    });
  }

  if (!esign.cache.warmingModeUpdated) {
    chart.addSeries({
      name: 'NDC average assessment',
      data: chartDotData,
      type: 'scatter',
      zIndex: 999,
      marker: {
        lineWidth: 2,
        radius: 8,
        lineColor: color,
        fillColor: color,
        symbol: 'circle',
        enabled: !!chartDotData
      },
      showInLegend: true
    });
  }

  //add new pledge
  chart.addSeries({
    visible:false,
    name: 'Custom pledge',
    data: chartDotData,
    type: 'scatter',
    zIndex: 999,
    marker: {
      symbol:
        "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAR5JREFUeNqUVFEVwjAMzDBAJcwBkzApk1AJSEDCJFTCJBQHkxAHI4UGjpBuj7x3H22aa5JrQ9u2kYXYIJgFWbAByvom6N04QxIEyRC0UEgDxneVhLquK9ksgjN97F7J9aJRcDH+UTj4uYKMGG5dmqW8CLMpPbzLNKXNHonTDiS8aoUDZnREZAhXiC3rp2q60Tuqplr27PgniI0E6WaHiI2CbBWEM+kE6iz0bdEoS3UdzV5WtU+wyeZQT38akgXjWxsxvEfY6lnv9Czv9Yzqt9DDoyP/tSI6RKjmpBk0bz54Z4wqq+P2D6HzAyJ+J+sszZ8aRJPpZfoZQQ6hpr8ArCAJq6BGw49mGWtp7jxDk9kWajmjeX9cs0nvGQb2EGAAfgvEdC8IS/gAAAAASUVORK5CYII=)"
      ,
      lineWidth: 2,
      radius: 8,
      lineColor: 'black',
      fillColor: 'black'
    },
    className: 'indc-tour',
    showInLegend: false
  });

  var updateCustomPledge = function (emission) {
    $(chart.series).each(function(i, serie) {
      if(serie.name === 'Custom pledge') {
        var closestY = chart.series[0].processedYData.reduce(function(prev, curr) {
          return (Math.abs(curr - emission) < Math.abs(prev - emission) ? curr : prev);
        });
        var closestYIndex = chart.series[0].processedYData.indexOf(closestY);
        var x = chart.series[0].processedXData[closestYIndex];
        serie.setData([[x,emission]]);
        serie.show();
      }
    });
  };

  var $customMarker = $('.customMarker');
  var $customMarkerClose = $('#custom-pledge-close');

  // showPledgeForm
  $('#addPlegde').click(function () {
    $customMarker.fadeIn();
    $customMarkerClose.fadeIn();
  });

  $customMarkerClose.click(function () {
    $customMarker.fadeOut();
    $customMarkerClose.fadeOut();
  });

  $('#updatePledge').click(function () {
    var emission = $('#emissions').val();

    if($.isNumeric(emission)){
      $customMarker.fadeOut();
      $customMarkerClose.fadeOut();

      updateCustomPledge(parseFloat(emission));
    }
  });

  $('#emissions').keypress(function (event) {
    if (event.keyCode === 13) {
      $('#updatePledge').click();
    }
  });

  // Exports
  esign.resetExportListeners();

  $('#export-chart-print').click(function () {
    chart.print();
  });
  $('#export-chart-png').click(function () {
    chart.exportChartLocal({
      type: 'image/png'
    });
  });
  $('#export-chart-jpg').click(function () {
    chart.exportChartLocal({
      type: 'image/jpeg'
    });
  });
  $('#export-chart-pdf').click(function () {
    chart.exportChartLocal({
      type: 'application/pdf'
    });
  });
  $('#export-chart-svg').click(function () {
    chart.exportChartLocal({
      type: 'image/svg+xml'
    });
  });

  // Show help
  $('#openRead').click(function () {
    $('#how-to-read').fadeIn();
    $('#how-to-read-close').fadeIn();
  });

  $('#how-to-read-close').click(function () {
    $('#how-to-read').fadeOut();
    $('#how-to-read-close').fadeOut();
  });

  $('#openRead2').click(function () {
    $('#how-to-read2').fadeIn();
    $('#how-to-read-close2').fadeIn();
  });

  $('#how-to-read-close2').click(function () {
    $('#how-to-read2').fadeOut();
    $('#how-to-read-close2').fadeOut();
  });

};

esign.createTrajectoryChart = function (year) {
  var yearMin = 1990,
    yearMax = 2100,
    unitK = 'ktCO2eq',
    unitM = 'MtCO2eq',
    unitG = 'GtCO2eq',
    unit = unitK,
    divider = 1;

  function getCountryIso(value) {
    return value['iso-a3'] === "'" + esign.cache.isoSelected + "'";
  }

  var dataTrajectories1 = esign.cache.warmingTrajectory1.filter(getCountryIso);
  var dataTrajectories2 = esign.cache.warmingTrajectory2.filter(getCountryIso);
  var trajectory1 = [], trajectory2 = [], trajectoryHistory = [];
  var maxValue = 0;

  if(esign.cache.isAbsolute) {
    for(var i = yearMin; i <= yearMax; i++) {
      trajectory1.push([i, dataTrajectories1[0][i]]);
      trajectory2.push([i, dataTrajectories2[0][i]]);
      max([dataTrajectories1[0][i], dataTrajectories2[0][i]]);
    }
  } else {
    for(var i = yearMin; i <= yearMax; i++) {
      // if(i >= year) {
        trajectory1.push([i, (dataTrajectories1[0][i]/dataTrajectories1[0][year])*100]);
        trajectory2.push([i,(dataTrajectories2[0][i]/dataTrajectories2[0][year])*100]);
      // }
    }
  }


  for(var i = 0; i <= 20; i++) {
    trajectoryHistory.push(trajectory1[i]);
  }

  function max(arr) {
    var m = Math.max.apply(null, arr);
    if(m > maxValue) maxValue = m;
  }

  if(maxValue > 999) {
    unit = unitM;
    divider = 1000;
  }
  if(maxValue > 999999) {
    unit = unitG;
    divider = 1000000;
  }

  var yAxis = {};

  if(esign.cache.isAbsolute) {
    // Absolute options
    yAxis = {
      title: {
        text: 'Emissions allowances in ' + unit
      },
      plotLines: [{
        value: 0,
        color: 'black',
        width: 2
      }],
      labels: {
        formatter: function () {
          if(unit === unitM) {
            return this.value / divider;
          } else if (unit === unitG) {
            return this.value / divider;
          }
          return this.value;
        }
      }
    };
    // filename = esign.cache.countrySelected + ' - Emissions allowances in ' + unit;
  } else {
    // Relative options
    yAxis = {
      title: {
        text: 'Emissions allowances in % of ' + year + ' levels'
      },
      plotLines: [{
        value: 100,
        color: 'black',
        dashStyle: 'shortdash',
        width: 2
      }, {
        value: 0,
        color: 'black',
        width: 2
      }],
      labels: {
        formatter: function () {
          return this.value;
        }
      }
    };
    // filename = esign.cache.countrySelected + ' - Emissions allowances in % of ' + relativeYear + ' levels (' + temp + ') [Downloaded from Paris-equity-check.org]';
  }


  var chartOptions = {
    chart: {
      renderTo: 'chart2',
      style: {
        fontFamily: 'Open Sans'
      },
      backgroundColor: '#ffffff'
    },
    title: {
     text: esign.cache.countrySelected,
      useHTML: true
    },
    subtitle: {
      text: '',
      style: {
        color: '#B4B4B4',
        fontSize: '5'
      },
      useHTML: true
    },
    xAxis: {
      title: {
        text: 'Year'
      }
    },
    yAxis: yAxis,
    tooltip: {
      crosshairs: true,
      shared: true,
      useHtml: true,
      borderWidth: 0,
      hideDelay: 30
    },
    legend: {
      title: {
        text: 'Legend',
        style: {
          fontWeight: 'normal'
        }
      },
      enabled: true,
      layout: 'vertical',
      floating: false,
      align: 'center left',
      itemStyle: {
        fontWeight: 'normal',
        fontSize: '10px'
      },
      itemMarginBottom: 1,
    },
    exporting: {
      enabled: false,
      filename: esign.cache.countrySelected + " - Emissions trajectories to stay below 2°C and 1.5°C",
      buttons: {
        contextButton: {
          verticalAlign: 'bottom',
          text: 'export'
        }
      },
      fallbackToExportServer: true,
      chartOptions:{
        credits: {
          enabled: true,
          href:"#",
          position: {
            align:"right",
            verticalAlign:"bottom",
            x: -10,
            y: -160,
          },
          style: {"cursor": "default", "font-size":"6pt"},
          text:"From Paris-equity-check.org, based on Robiou du Pont et al. (2018), Nature Communications"
        }
      }
    },
    credits: false,
    series: [{
      name: '2°C-scenario',
      data: trajectory2,
      zIndex: 10,
      color: '#E1E000',
      marker: {
        lineWidth: 0,
        radius: 0,
        symbol: 'circle',
        lineColor: 'transparent'
      },
      zoneAxis: 'x',
      zones: [{
        value: 2010,
        color: 'transparent'
      }]
    },{
      name: '1.5°C-scenario',
      data: trajectory1,
      zIndex: 10,
      color: '#74AB00',
      marker: {
        lineWidth: 0,
        radius: 0,
        symbol: 'circle',
        lineColor: 'transparent'
      },
      zoneAxis: 'x',
      zones: [{
        value: 2010,
        color: 'transparent'
      }]
    },{
      name: 'Historical emissions',
      data: trajectoryHistory,
      zIndex: 1,
      color: '#000000',
      marker: {
        lineWidth: 0,
        radius: 0,
        symbol: 'circle',
        lineColor: 'transparent'
      },
      zoneAxis: 'x',
      zones: [{
        value: 2010,
        color: '#000000'
      }]
    }]
  };

  var chart = new Highcharts.Chart(chartOptions);

  chart.tooltip.options.formatter = function() {
    var points = this.points || Highcharts.splat(this),
      txt = '';

    txt += '<span class="tooltip-year">' + this.x + '</span><br>';

    if(this.x <= 2010) {
      if(typeof this.point === 'undefined') {
        txt += 'Historical emissions: ' + (this.y/divider).toPrecision(3);
      }
    } else {
      if(esign.cache.isAbsolute) {
        Highcharts.each(points, function(p, i){
          var name = p.series.name;

          txt += name + ': ' + (p.y/divider).toPrecision(3) + ' ' + unit + '<br>';
        });
      } else {
        Highcharts.each(points, function(p, i){
          var name = p.series.name;

          txt += name + ': ' + (p.y/divider).toPrecision(3) + '%<br>';
        });
      }
    }
    return txt;
  };

  // Exports
  esign.resetExportListeners2();

  $('#export-chart-print2').click(function () {
    chart.print();
  });
  $('#export-chart-png2').click(function () {
    chart.exportChartLocal({
      type: 'image/png'
    });
  });
  $('#export-chart-jpg2').click(function () {
    chart.exportChartLocal({
      type: 'image/jpeg'
    });
  });
  $('#export-chart-pdf2').click(function () {
    chart.exportChartLocal({
      type: 'application/pdf'
    });
  });
  $('#export-chart-svg2').click(function () {
    chart.exportChartLocal({
      type: 'image/svg+xml'
    });
  });
};

esign.round = function (value, decimals) {
  return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
};

esign.decodeHTML = function (html) {
  var txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};

esign.getValueByIso = function(arr, iso) {
  function getCountryIso(value) {
    return value['iso-a3'] === iso;
  }
  return arr.filter(getCountryIso)[0];
}

require([
  'requirejs/require',
  'jquery/dist/jquery',
  'js/polyfills/native-console',
  'response.js/response',
  'jquery-touchswipe/jquery.touchSwipe',
  'bootstrap/dist/js/bootstrap',
  'list.js/dist/list',
  'jquery-match-height/dist/jquery.matchHeight',
  'jquery-placeholder/jquery.placeholder',
  'qtip2/dist/jquery.qtip',
  'list.js/dist/list',
  'tinycolor2/tinycolor',
  'js/highcharts/highcharts',
  'js/highcharts/highcharts-more',
  'js/highcharts/map',
  'js/highcharts/exporting',
  'js/highcharts/offline-exporting',
  'js/highcharts/world-eckert3-highres.mod',
], function() {
  require(['tinycolor2/tinycolor'], function(tinycolor){
    window.tinycolor = tinycolor;

    // Initialize on docready
    $(esign.init);
  });
});

define("../resources/assets/js/esign", function(){});

